var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _polygon, _path13, _polygon2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMaintenance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M637.46,465.28v-1.44a6,6,0,0,1,6-6h50.89a6,6,0,0,1,6,6v1.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667,400.73,648.55,457.8h39.32l-17.08-57A2,2,0,0,0,667,400.73Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "660.97 419.31 676.34 419.31 682.99 441.51 653.81 441.51 660.97 419.31",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.71,464V462.6a6,6,0,0,1,6-6h50.89a6,6,0,0,1,6,6V464Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.22,399.49l-18.41,57.07h39.32l-17.09-57A2,2,0,0,0,296.22,399.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "290.22 418.07 305.6 418.07 312.25 440.27 283.06 440.27 290.22 418.07",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.05,84,265,75.16l-7.92,1.17-6.54-8.22,3.37-8.18-8.83-5.86-6.59,6.65L229.8,59.2,226.28,49,215.73,50.1l-.6,8.93-7.86,4L199,57.13l-8.44,6.15,4.39,9.45-5,7.57-9.12-.48-2.39,11.25,8.69,3.34.74,9.46-9,5.17,4.3,9.76,9.32-1.44,6.18,7.12-3.23,8.88,8.53,6,6.66-7.21,9.25,2.5,2.87,9.54,10.27-.69,1.33-8.57,8.8-5.06,7.21,5.75,9.11-6.79-4.61-8,4.49-8,9.24.68L271.35,103l-7.93-4.29-1.06-9.55Zm-35.78,30.82a20.76,20.76,0,1,1,7.67-28.34A20.75,20.75,0,0,1,234.27,114.79Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.13,90.75a24.71,24.71,0,0,0-1.71-2.08A10.93,10.93,0,0,0,225,85.53a10.74,10.74,0,0,0-9.59,3.76A10.88,10.88,0,0,0,213,95a10.69,10.69,0,0,0,6.31,11,10.45,10.45,0,0,0,3.1.85,10.22,10.22,0,0,0,3.08-.08,10.89,10.89,0,0,0,5.14-2.39,10.71,10.71,0,0,0,2.95-4,11,11,0,0,0,.53-7.13,25.2,25.2,0,0,0-.94-2.53,8.76,8.76,0,0,1,1.13,2.47,10.92,10.92,0,0,1-.38,7.33,11.09,11.09,0,0,1-8.34,6.71,10.56,10.56,0,0,1-3.23.1,10.35,10.35,0,0,1-3.25-.88A11.18,11.18,0,0,1,212.45,95a10.63,10.63,0,0,1,.88-3.25A10.82,10.82,0,0,1,215,89a11.25,11.25,0,0,1,4.88-3.33,11.07,11.07,0,0,1,5.12-.49,11,11,0,0,1,6.53,3.37A8.71,8.71,0,0,1,233.13,90.75Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243,67.63c.12.08-2.69,4.57-6.29,10s-6.6,9.82-6.72,9.75,2.69-4.57,6.29-10S242.88,67.55,243,67.63Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.2,104a18.36,18.36,0,0,1-2.8-.77c-1.71-.52-4.08-1.21-6.73-1.86s-5.07-1.13-6.83-1.45a19.86,19.86,0,0,1-2.84-.6,14,14,0,0,1,2.9.23,68.54,68.54,0,0,1,6.89,1.32,64.71,64.71,0,0,1,6.73,2A14.6,14.6,0,0,1,253.2,104Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.24,106.37a11.52,11.52,0,0,1,.9,2.42c.48,1.53,1.07,3.65,1.62,6s1,4.54,1.2,6.12a13,13,0,0,1,.27,2.57,12.65,12.65,0,0,1-.63-2.51c-.34-1.55-.8-3.7-1.35-6.07s-1.08-4.49-1.46-6A14,14,0,0,1,228.24,106.37Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217,105.1a69.57,69.57,0,0,1-4.12,7.33,70.14,70.14,0,0,1-4.56,7.07,66,66,0,0,1,4.12-7.34A66,66,0,0,1,217,105.1Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.44,69.7a65.06,65.06,0,0,1,2.65,7.72,64.47,64.47,0,0,1,2.15,7.87,64.27,64.27,0,0,1-2.65-7.72A61.86,61.86,0,0,1,215.44,69.7Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.09,94.14a41.44,41.44,0,0,1-6.49-.36,41.13,41.13,0,0,1-6.43-.87,38.63,38.63,0,0,1,6.48.36A41.63,41.63,0,0,1,213.09,94.14Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231,92a8.56,8.56,0,1,1-11.69-3.17A8.56,8.56,0,0,1,231,92Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.74,96.28a11.63,11.63,0,0,0-4.24-1.62,11.47,11.47,0,0,0-4.5.68c0-.06.38-.41,1.19-.74a7,7,0,0,1,3.36-.46,7.13,7.13,0,0,1,3.19,1.17C227.45,95.81,227.79,96.24,227.74,96.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.31,91.27a28.07,28.07,0,0,0-1.29,4,28.25,28.25,0,0,0-.18,4.18,8.48,8.48,0,0,1,1.47-8.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.19,262.29l-6.54-11.4-10.24,1.51L357,241.77l4.36-10.59-11.43-7.58-8.53,8.6-11.23-2L325.57,217l-13.65,1.44L311.14,230,301,235.19l-10.76-7.63-10.92,8L285,247.75l-6.5,9.79-11.81-.63-3.08,14.57,11.24,4.32,1,12.24-11.64,6.69,5.56,12.63,12.06-1.88,8,9.22-4.17,11.49,11,7.8,8.62-9.32,12,3.23,3.72,12.34,13.29-.89,1.71-11.09,11.4-6.54,9.32,7.44,11.79-8.79-6-10.38,5.81-10.41,11.95.88,3.67-13.55-10.27-5.56L372.25,269ZM335.9,302.17a26.86,26.86,0,1,1,9.92-36.67A26.87,26.87,0,0,1,335.9,302.17Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.43,271.06a27,27,0,0,0-2.19-2.71,14.11,14.11,0,0,0-8.33-4.1,13.9,13.9,0,0,0-6.41.68,14.13,14.13,0,0,0-6.05,4.2,14,14,0,0,0-3.19,7.45,13.88,13.88,0,0,0,8.21,14.3,13.24,13.24,0,0,0,4,1.11,13.42,13.42,0,0,0,4-.11,14.09,14.09,0,0,0,11.16-17.56,28.76,28.76,0,0,0-1.24-3.26,1.13,1.13,0,0,1,.12.2l.33.59a7.1,7.1,0,0,1,.48,1,10.08,10.08,0,0,1,.5,1.42,13.25,13.25,0,0,1,.58,4.1,14.38,14.38,0,0,1-5,10.74,14.46,14.46,0,0,1-6.88,3.25,13.37,13.37,0,0,1-4.15.13,13.68,13.68,0,0,1-4.18-1.13,14.37,14.37,0,0,1-8.51-14.83,14.45,14.45,0,0,1,3.33-7.7,14.44,14.44,0,0,1,6.28-4.29,14.27,14.27,0,0,1,11.78,1.12,13.33,13.33,0,0,1,3.25,2.56,10.23,10.23,0,0,1,1,1.15,7.42,7.42,0,0,1,.62.91l.34.59A1.75,1.75,0,0,1,334.43,271.06Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.2,241.15c.13.08-3.55,5.87-8.2,12.93s-8.52,12.73-8.64,12.65,3.56-5.87,8.21-12.93S347.08,241.07,347.2,241.15Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.4,288.16a35.71,35.71,0,0,1-3.6-1.06c-2.22-.69-5.29-1.58-8.71-2.42s-6.57-1.46-8.85-1.87a37.51,37.51,0,0,1-3.69-.71,3.29,3.29,0,0,1,1,0c.65.05,1.58.16,2.74.32,2.3.32,5.46.88,8.91,1.72s6.51,1.8,8.7,2.58c1.1.39,2,.72,2.57,1A3.45,3.45,0,0,1,360.4,288.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.11,291.27a20.53,20.53,0,0,1,1.11,3.15c.6,2,1.36,4.73,2.07,7.79s1.25,5.88,1.57,7.92a19,19,0,0,1,.4,3.32,24.55,24.55,0,0,1-.76-3.26c-.42-2-1-4.8-1.72-7.86s-1.41-5.81-1.92-7.81A24.32,24.32,0,0,1,328.11,291.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.6,289.62c.12.08-2.29,4.31-5.4,9.45a108.58,108.58,0,0,1-5.84,9.18c-.12-.07,2.29-4.3,5.4-9.45S313.48,289.55,313.6,289.62Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.54,243.83c.14,0,1.64,4.44,3.36,10s3,10.11,2.85,10.15-1.64-4.43-3.35-10A105.46,105.46,0,0,1,311.54,243.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.5,275.45a69.15,69.15,0,0,1-8.39-.54,65.74,65.74,0,0,1-8.33-1.06,69,69,0,0,1,8.38.54A68.35,68.35,0,0,1,308.5,275.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322.11,
    cy: 278.14,
    r: 11.08,
    transform: "translate(-5.19 550.15) rotate(-80.54)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.46,278.22a16.42,16.42,0,0,1-1.52-.9,10.27,10.27,0,0,0-8.11-.88c-1,.31-1.64.63-1.68.56s.51-.49,1.56-.91a9.21,9.21,0,0,1,8.42.91A3.93,3.93,0,0,1,327.46,278.22Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323,271.73a26,26,0,0,0-1.75,5.14,26.67,26.67,0,0,0-.15,5.43,11.5,11.5,0,0,1,1.9-10.57Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386,69.59l-3.29-5.73-5.16.76-4.26-5.35,2.2-5.33-5.75-3.82-4.29,4.33-5.66-1-2.29-6.65-6.87.73-.39,5.81L345.14,56l-5.42-3.83-5.5,4,2.86,6.16-3.27,4.92-5.94-.31-1.56,7.33L332,76.4l.49,6.16-5.87,3.36,2.81,6.36,6.06-.94,4,4.64-2.1,5.78,5.56,3.93,4.34-4.7,6,1.63,1.87,6.21,6.69-.45.86-5.58,5.74-3.29,4.69,3.74,5.93-4.42-3-5.23L379,88.37l6,.44L386.87,82l-5.17-2.8L381,73Zm-23.3,20.08a13.52,13.52,0,1,1,5-18.46A13.52,13.52,0,0,1,362.72,89.67Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362,74a11.85,11.85,0,0,0-1.1-1.37,7.16,7.16,0,0,0-4.19-2.06,6.93,6.93,0,0,0-3.23.35,7,7,0,0,0-3,2.11,7,7,0,0,0-1.6,3.75,7,7,0,0,0,.88,4.28A7.1,7.1,0,0,0,352.94,84a6.66,6.66,0,0,0,2,.55,6.5,6.5,0,0,0,2-.05,7,7,0,0,0,3.36-1.57,6.82,6.82,0,0,0,1.92-2.61,7.05,7.05,0,0,0,.33-4.66A13.09,13.09,0,0,0,362,74l.06.1.17.3a4,4,0,0,1,.24.5,5.23,5.23,0,0,1,.25.71,6.72,6.72,0,0,1,.29,2.06,7.13,7.13,0,0,1-.54,2.7,7.21,7.21,0,0,1-2,2.71A7.3,7.3,0,0,1,357,84.73a6.63,6.63,0,0,1-2.09.06,6.56,6.56,0,0,1-2.1-.57,7.25,7.25,0,0,1-3.38-3,7.38,7.38,0,0,1-.91-4.44,7.24,7.24,0,0,1,1.68-3.88,7.3,7.3,0,0,1,3.16-2.16,7.28,7.28,0,0,1,5.93.56A7,7,0,0,1,361,72.57a4.59,4.59,0,0,1,.49.58,2.85,2.85,0,0,1,.31.46l.18.3A.36.36,0,0,1,362,74Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.41,59c.06,0-1.79,3-4.13,6.51s-4.28,6.41-4.35,6.37,1.79-3,4.13-6.51S368.35,58.91,368.41,59Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.05,82.62a18.86,18.86,0,0,1-1.81-.54c-1.11-.34-2.66-.79-4.39-1.22s-3.3-.73-4.45-.93a15.31,15.31,0,0,1-1.85-.37,2.37,2.37,0,0,1,.5,0c.33,0,.8.08,1.38.16,1.16.16,2.75.45,4.49.87s3.28.91,4.38,1.3c.55.19,1,.36,1.29.49A1.55,1.55,0,0,1,375.05,82.62Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.8,84.18a10.41,10.41,0,0,1,.56,1.59c.3,1,.68,2.38,1,3.92s.63,3,.79,4a8.58,8.58,0,0,1,.2,1.68,12,12,0,0,1-.38-1.64c-.21-1-.51-2.42-.86-4s-.71-2.93-1-3.93A11.16,11.16,0,0,1,358.8,84.18Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.5,83.35c.06,0-1.16,2.17-2.72,4.76s-2.88,4.66-2.94,4.62S347,90.56,348.56,88,351.43,83.32,351.5,83.35Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.46,60.3c.07,0,.82,2.24,1.69,5s1.51,5.09,1.44,5.11a52.17,52.17,0,0,1-1.69-5A52.27,52.27,0,0,1,350.46,60.3Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.93,76.22a34.9,34.9,0,0,1-4.22-.27,31.38,31.38,0,0,1-4.2-.54,33.84,33.84,0,0,1,4.22.28A34.36,34.36,0,0,1,348.93,76.22Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.61,74.8A5.57,5.57,0,1,1,353,72.74,5.56,5.56,0,0,1,360.61,74.8Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.47,77.61s-.29-.19-.76-.45a5.53,5.53,0,0,0-2-.64,5.3,5.3,0,0,0-2.09.2c-.52.15-.82.31-.84.28a1.84,1.84,0,0,1,.78-.46,4.68,4.68,0,0,1,4.24.46A2,2,0,0,1,358.47,77.61Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.24,74.35a13.31,13.31,0,0,0-.88,2.58,13.39,13.39,0,0,0-.08,2.74,5,5,0,0,1-.18-2.78A4.85,4.85,0,0,1,356.24,74.35Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.92,210.84l-8.29-14.44-13,1.91-10.72-13.47,5.52-13.41L206,161.82l-10.81,10.9-14.23-2.5-5.78-16.73-17.29,1.82-1,14.64L144,176.5l-13.64-9.66-13.84,10.08,7.19,15.5-8.24,12.4-15-.79L96.6,222.49,110.84,228l1.22,15.51L97.31,252l7,16,15.28-2.37,10.12,11.68-5.3,14.56,14,9.88,10.92-11.82,15.15,4.1,4.72,15.64,16.84-1.13,2.17-14.05,14.44-8.29,11.81,9.43,14.94-11.14-7.55-13.15,7.36-13.19,15.14,1.12L249.05,242l-13-7-1.73-15.64Zm-58.66,50.53a34,34,0,1,1,12.57-46.47A34,34,0,0,1,188.26,261.37Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.39,222a32.37,32.37,0,0,0-2.77-3.44,18,18,0,0,0-10.55-5.2,17.7,17.7,0,0,0-15.8,6.19,16.56,16.56,0,0,0-2.67,4.32,16.37,16.37,0,0,0-1.37,5.12,17.6,17.6,0,0,0,10.4,18.12,16.57,16.57,0,0,0,5.11,1.4,16.34,16.34,0,0,0,5.09-.13A17.84,17.84,0,0,0,188,226.09a30.44,30.44,0,0,0-1.57-4.13s.06.08.16.24.25.45.42.75a9.05,9.05,0,0,1,.6,1.27,12,12,0,0,1,.64,1.8,16.85,16.85,0,0,1,.73,5.18,18.17,18.17,0,0,1-6.3,13.61,18.33,18.33,0,0,1-8.71,4.13,18.36,18.36,0,0,1-10.56-1.27,18.21,18.21,0,0,1-10.78-18.79,18.26,18.26,0,0,1,4.22-9.76,18.16,18.16,0,0,1,22.88-4,16.92,16.92,0,0,1,4.11,3.25A12.08,12.08,0,0,1,185,219.8a8.58,8.58,0,0,1,.79,1.16c.18.29.32.54.44.74A1.21,1.21,0,0,1,186.39,222Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.58,184.05c.15.1-4.5,7.44-10.39,16.39s-10.8,16.13-10.95,16,4.5-7.43,10.4-16.39S202.43,184,202.58,184.05Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.3,243.62a42.31,42.31,0,0,1-4.56-1.34c-2.81-.87-6.7-2-11-3.07s-8.33-1.84-11.21-2.36a41.12,41.12,0,0,1-4.67-.91,5,5,0,0,1,1.28,0c.82.07,2,.21,3.46.41,2.92.4,6.93,1.12,11.29,2.18s8.26,2.28,11,3.27c1.39.49,2.5.91,3.26,1.23A4.72,4.72,0,0,1,219.3,243.62Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.38,247.56a23.67,23.67,0,0,1,1.41,4c.76,2.5,1.72,6,2.63,9.87s1.57,7.45,2,10a24.33,24.33,0,0,1,.5,4.21,30.91,30.91,0,0,1-1-4.12c-.53-2.56-1.28-6.09-2.18-10s-1.78-7.37-2.43-9.9A30.27,30.27,0,0,1,178.38,247.56Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,245.48c.15.09-2.91,5.45-6.84,12s-7.24,11.73-7.4,11.64,2.9-5.46,6.84-12S159.84,245.38,160,245.48Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.39,187.45c.17,0,2.08,5.62,4.25,12.68s3.8,12.82,3.62,12.87-2.08-5.62-4.25-12.68S157.21,187.5,157.39,187.45Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.54,227.52c0,.18-4.78-.13-10.63-.69s-10.58-1.15-10.56-1.34,4.77.13,10.62.69S153.55,227.34,153.54,227.52Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 170.78,
    cy: 230.92,
    r: 14.04,
    transform: "translate(-98.47 330.9) rotate(-73.89)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.56,231a21.37,21.37,0,0,1-1.93-1.14,13.34,13.34,0,0,0-5-1.62,13.52,13.52,0,0,0-5.26.5,19.33,19.33,0,0,1-2.13.71,4.91,4.91,0,0,1,2-1.15,11.79,11.79,0,0,1,5.48-.72,11.66,11.66,0,0,1,5.19,1.88A4.94,4.94,0,0,1,177.56,231Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.93,222.8c.19.11-1.56,2.76-2.21,6.52s0,6.84-.19,6.88-1.18-3.08-.46-7S171.83,222.68,171.93,222.8Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.28,202.09,622,187.65l-13,1.91-10.72-13.47,5.53-13.42-14.48-9.6L578.52,164l-14.23-2.49-5.77-16.74-17.3,1.83-1,14.64-12.89,6.55-13.64-9.66-13.84,10.08,7.19,15.49-8.23,12.41-15-.79L480,213.73l14.23,5.48,1.23,15.51-14.76,8.47,7,16L503,256.82l10.12,11.69-5.29,14.55,14,9.89,10.92-11.82,15.16,4.1,4.71,15.64,16.84-1.14,2.17-14,14.44-8.29,11.82,9.42,14.93-11.13-7.55-13.16,7.36-13.18,15.15,1.11,4.65-17.17-13-7-1.73-15.65Zm-58.67,50.53a34,34,0,1,1,12.57-46.47A34,34,0,0,1,571.61,252.62Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.74,213.21a30.78,30.78,0,0,0-2.77-3.44,17.79,17.79,0,0,0-26.34,1,17.73,17.73,0,0,0-4,9.44A17.62,17.62,0,0,0,547,238.32a16.7,16.7,0,0,0,5.11,1.4,16.9,16.9,0,0,0,5.08-.13,17.74,17.74,0,0,0,13.31-10.53,17.94,17.94,0,0,0,.83-11.73,30.51,30.51,0,0,0-1.58-4.12s.07.07.16.24l.42.75a7.9,7.9,0,0,1,.6,1.26,13.63,13.63,0,0,1,.65,1.8,17.23,17.23,0,0,1,.73,5.19,18.17,18.17,0,0,1-6.3,13.61,18.36,18.36,0,0,1-8.72,4.13,18.23,18.23,0,0,1-10.55-1.28,18.18,18.18,0,0,1-10.79-18.79,18.27,18.27,0,0,1,4.22-9.75,18.28,18.28,0,0,1,8-5.45,18.23,18.23,0,0,1,14.93,1.42,17.12,17.12,0,0,1,4.11,3.25,13.27,13.27,0,0,1,1.23,1.46,9.25,9.25,0,0,1,.79,1.15l.43.74C569.71,213.11,569.75,213.2,569.74,213.21Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.94,175.3c.15.1-4.5,7.44-10.4,16.39s-10.79,16.13-10.94,16,4.5-7.44,10.39-16.39S585.78,175.2,585.94,175.3Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.66,234.87a44.22,44.22,0,0,1-4.57-1.34c-2.8-.87-6.69-2-11-3.07s-8.32-1.84-11.21-2.36a44.81,44.81,0,0,1-4.67-.91,4.49,4.49,0,0,1,1.28,0c.82.07,2,.2,3.46.41a114.1,114.1,0,0,1,11.3,2.18c4.36,1.07,8.25,2.28,11,3.26,1.38.49,2.5.92,3.26,1.24A5,5,0,0,1,602.66,234.87Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.74,238.81a23.87,23.87,0,0,1,1.4,4c.77,2.5,1.73,6,2.63,9.87s1.58,7.45,2,10a25.12,25.12,0,0,1,.51,4.21,29.74,29.74,0,0,1-1-4.13c-.53-2.55-1.27-6.08-2.17-10s-1.79-7.37-2.44-9.9A29.83,29.83,0,0,1,561.74,238.81Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.35,236.72c.16.1-2.9,5.46-6.83,12s-7.25,11.73-7.41,11.63,2.91-5.45,6.84-12S543.2,236.63,543.35,236.72Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.74,178.7c.18-.06,2.08,5.62,4.25,12.68s3.8,12.82,3.63,12.87-2.08-5.62-4.26-12.68S540.57,178.75,540.74,178.7Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.89,218.76c0,.19-4.78-.12-10.63-.68s-10.58-1.16-10.56-1.34,4.78.13,10.63.68S536.91,218.58,536.89,218.76Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 554.13,
    cy: 222.17,
    r: 14.04,
    transform: "translate(193.29 697.79) rotate(-74.66)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.91,222.28a21.13,21.13,0,0,1-1.92-1.15,13.76,13.76,0,0,0-5-1.62,13.43,13.43,0,0,0-5.25.51,18.52,18.52,0,0,1-2.13.7,5,5,0,0,1,2-1.14,11.67,11.67,0,0,1,10.67,1.16C560.41,221.53,561,222.22,560.91,222.28Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.29,214.05c.18.1-1.56,2.75-2.22,6.51s0,6.85-.19,6.88-1.18-3.07-.45-7S555.18,213.93,555.29,214.05Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.2,291.36l-4.07-7.1-6.39.93-5.27-6.62,2.72-6.59-7.12-4.73-5.31,5.36-7-1.23-2.84-8.23-8.51.9-.48,7.2-6.34,3.22-6.71-4.75-6.8,5,3.54,7.62-4.05,6.1-7.36-.39-1.92,9.07,7,2.7.6,7.62-7.26,4.17,3.47,7.87,7.51-1.17,5,5.75-2.6,7.16,6.88,4.86,5.37-5.81,7.45,2,2.32,7.69,8.28-.56,1.07-6.9,7.1-4.08,5.81,4.64,7.34-5.48-3.71-6.47,3.62-6.48,7.45.54,2.28-8.44-6.39-3.46-.85-7.7Zm-28.84,24.85a16.74,16.74,0,1,1,6.18-22.85A16.74,16.74,0,0,1,448.36,316.21Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.44,296.83a14.76,14.76,0,0,0-1.36-1.7,8.81,8.81,0,0,0-5.19-2.55,8.73,8.73,0,0,0-7.77,3,8.08,8.08,0,0,0-1.31,2.13,8.19,8.19,0,0,0-.68,2.51,8.67,8.67,0,0,0,5.12,8.91,8.76,8.76,0,0,0,5,.63,8.82,8.82,0,0,0,4.16-1.94,8.84,8.84,0,0,0,2.79-9,15.45,15.45,0,0,0-.77-2s0,0,.08.11l.2.37a4.17,4.17,0,0,1,.3.63,7.26,7.26,0,0,1,.32.88,8.34,8.34,0,0,1,.35,2.55,8.71,8.71,0,0,1-.67,3.34,8.84,8.84,0,0,1-2.42,3.35,9,9,0,0,1-4.29,2,8.55,8.55,0,0,1-2.58.08,8.18,8.18,0,0,1-2.61-.71,8.92,8.92,0,0,1-5.3-9.23,8.93,8.93,0,0,1,2.07-4.8,9.06,9.06,0,0,1,3.91-2.68,8.88,8.88,0,0,1,4.12-.4,9,9,0,0,1,3.23,1.1,8.61,8.61,0,0,1,2,1.59,6.7,6.7,0,0,1,.6.72,4.9,4.9,0,0,1,.39.57l.22.37Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.4,278.18c.08.05-2.21,3.66-5.11,8.06s-5.31,7.94-5.38,7.89,2.21-3.66,5.11-8.06S455.33,278.14,455.4,278.18Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.62,307.48s-.86-.24-2.24-.66-3.29-1-5.43-1.51-4.09-.91-5.51-1.16a21,21,0,0,1-2.3-.45,2.75,2.75,0,0,1,.63,0c.4,0,1,.1,1.7.2,1.44.2,3.41.55,5.56,1.07s4.06,1.12,5.42,1.61c.68.24,1.23.45,1.6.6A2.23,2.23,0,0,1,463.62,307.48Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.5,309.41a11.66,11.66,0,0,1,.69,2c.38,1.23.85,2.94,1.3,4.86s.77,3.66,1,4.93a11.78,11.78,0,0,1,.25,2.07,16.36,16.36,0,0,1-.47-2c-.26-1.26-.63-3-1.07-4.9s-.88-3.63-1.2-4.87A15.18,15.18,0,0,1,443.5,309.41Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.46,308.39c.08.05-1.43,2.68-3.36,5.89s-3.56,5.76-3.64,5.72,1.43-2.68,3.36-5.89A67.06,67.06,0,0,1,434.46,308.39Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.18,279.86c.08,0,1,2.76,2.09,6.23a64.47,64.47,0,0,1,1.78,6.33,64.82,64.82,0,0,1-2.09-6.23A65.35,65.35,0,0,1,433.18,279.86Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.28,299.56a85.57,85.57,0,0,1-10.42-1,41.53,41.53,0,0,1,5.23.34A40.68,40.68,0,0,1,431.28,299.56Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 439.76,
    cy: 301.23,
    r: 6.9,
    transform: "translate(18.41 627.72) rotate(-72.18)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.1,301.29s-.36-.24-1-.57a6.83,6.83,0,0,0-2.47-.79,6.49,6.49,0,0,0-2.58.25,9.38,9.38,0,0,1-1.05.34,2.45,2.45,0,0,1,1-.56,5.7,5.7,0,0,1,5.25.57A2.43,2.43,0,0,1,443.1,301.29Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.33,297.24a11.25,11.25,0,0,0-1.18,6.58,6,6,0,0,1-.23-3.43A6.11,6.11,0,0,1,440.33,297.24Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.81,91.5l-6.54-11.4L509,81.61,500.56,71l4.36-10.59L493.5,52.81,485,61.41l-11.23-2-4.56-13.2-13.65,1.44-.77,11.55L444.59,64.4l-10.77-7.63-10.92,8L428.57,77l-6.49,9.79-11.81-.63-3.09,14.57L418.42,105l1,12.24-11.65,6.69,5.57,12.63,12.05-1.88,8,9.22-4.18,11.49,11.05,7.8,8.61-9.32,12,3.23,3.72,12.34,13.29-.89,1.72-11.09,11.39-6.54,9.32,7.44L512,149.58l-6-10.38,5.81-10.41,12,.88,3.67-13.55-10.26-5.56-1.37-12.34Zm-46.29,39.88a26.87,26.87,0,1,1,9.92-36.68A26.87,26.87,0,0,1,479.52,131.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478,100.27a25.27,25.27,0,0,0-2.19-2.71,14.07,14.07,0,0,0-8.32-4.1,13.88,13.88,0,0,0-6.41.68,14.1,14.1,0,0,0-6.06,4.2,14,14,0,0,0-3.19,7.45,13.88,13.88,0,0,0,8.21,14.3,13.31,13.31,0,0,0,4,1.11,13.48,13.48,0,0,0,4-.11,14,14,0,0,0,10.5-8.3,14.18,14.18,0,0,0,.65-9.26,24.6,24.6,0,0,0-1.24-3.26.82.82,0,0,1,.13.2l.33.59a6.18,6.18,0,0,1,.47,1,10,10,0,0,1,.51,1.42,13.83,13.83,0,0,1,.58,4.1,14.32,14.32,0,0,1-11.85,14,13.37,13.37,0,0,1-4.15.13,13.53,13.53,0,0,1-4.18-1.13,14.36,14.36,0,0,1-8.52-14.83,13.9,13.9,0,0,1,1.13-4.18A13.52,13.52,0,0,1,454.7,98,14.41,14.41,0,0,1,461,93.74a14.16,14.16,0,0,1,6.6-.65,14.49,14.49,0,0,1,5.19,1.76A13.71,13.71,0,0,1,476,97.42a9.27,9.27,0,0,1,1,1.15,6.43,6.43,0,0,1,.62.91l.35.59A.92.92,0,0,1,478,100.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.82,70.36c.12.08-3.55,5.87-8.2,12.93S474.1,96,474,95.94s3.55-5.87,8.2-12.93S490.7,70.28,490.82,70.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504,117.37a36.62,36.62,0,0,1-3.6-1.06c-2.21-.69-5.28-1.58-8.71-2.42s-6.57-1.46-8.85-1.87a36.83,36.83,0,0,1-3.68-.71,3.25,3.25,0,0,1,1,0c.65,0,1.58.16,2.73.32,2.3.32,5.47.88,8.91,1.72a90.71,90.71,0,0,1,8.71,2.58c1.09.39,2,.72,2.57,1A3.26,3.26,0,0,1,504,117.37Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.72,120.47a18.54,18.54,0,0,1,1.11,3.16c.6,2,1.36,4.73,2.08,7.79s1.24,5.88,1.57,7.92a18.29,18.29,0,0,1,.39,3.32,24.55,24.55,0,0,1-.76-3.26c-.41-2-1-4.8-1.71-7.86s-1.41-5.81-1.93-7.81A23.85,23.85,0,0,1,471.72,120.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.21,118.83c.13.08-2.29,4.31-5.39,9.45s-5.72,9.26-5.84,9.18,2.29-4.3,5.39-9.45S457.09,118.76,457.21,118.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.15,73c.14,0,1.64,4.44,3.36,10s3,10.12,2.86,10.16a105.2,105.2,0,0,1-3.36-10C456.3,77.63,455,73.08,455.15,73Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.11,104.66a135.39,135.39,0,0,1-16.72-1.6,69.06,69.06,0,0,1,8.39.54A68,68,0,0,1,452.11,104.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 465.72,
    cy: 107.35,
    r: 11.08,
    transform: "matrix(0.96, -0.27, 0.27, 0.96, -11.69, 129.58)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.07,107.43c-.05.06-.58-.38-1.52-.9a10.26,10.26,0,0,0-8.11-.88c-1,.31-1.64.63-1.68.56a3.73,3.73,0,0,1,1.56-.91,9.21,9.21,0,0,1,8.42.91C470.67,106.84,471.12,107.39,471.07,107.43Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.63,100.94a27.23,27.23,0,0,0-1.74,5.14,27.15,27.15,0,0,0-.16,5.43,11.5,11.5,0,0,1,1.9-10.57Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324,113.32l-1.7-3-2.65.39L317.4,108l1.13-2.75-3-2-2.21,2.23-2.91-.51-1.18-3.43-3.54.38-.2,3-2.63,1.34-2.79-2-2.83,2.06,1.47,3.17-1.69,2.53-3.06-.16-.8,3.78,2.91,1.12.26,3.17-3,1.73,1.44,3.28,3.12-.49L300,126.9l-1.08,3,2.86,2,2.24-2.42,3.1.84,1,3.2,3.45-.23.44-2.88,2.95-1.69,2.42,1.93,3.05-2.28-1.54-2.69,1.51-2.7,3.09.23.95-3.51-2.66-1.44-.35-3.2Zm-12,10.33a7,7,0,1,1,2.57-9.5A7,7,0,0,1,312,123.65Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.57,115.59s-.21-.26-.62-.65a3.69,3.69,0,0,0-2.13-1,3.46,3.46,0,1,0,2.77,4.82,3.75,3.75,0,0,0,.23-2.33c-.13-.55-.29-.84-.25-.86a1.86,1.86,0,0,1,.44.81,3.6,3.6,0,0,1-.08,2.52,3.84,3.84,0,0,1-2.88,2.36,3.9,3.9,0,0,1-3.67-6.39,3.88,3.88,0,0,1,3.49-1.3,3.65,3.65,0,0,1,2.22,1.21A1.9,1.9,0,0,1,311.57,115.59Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.88,107.84a15.29,15.29,0,0,1-2,3.45,15,15,0,0,1-2.4,3.18,15.23,15.23,0,0,1,2-3.46A15.09,15.09,0,0,1,314.88,107.84Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.3,120a17.16,17.16,0,0,1-3.24-.71,16.85,16.85,0,0,1-3.2-.86A12.47,12.47,0,0,1,318.3,120Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.93,120.83a7.34,7.34,0,0,1,1,2.79,7.13,7.13,0,0,1,.32,2.95,10.24,10.24,0,0,1-.82-2.83A10.32,10.32,0,0,1,309.93,120.83Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.17,120.4a8,8,0,0,1-1.23,2.55,8.18,8.18,0,0,1-1.68,2.28,7.66,7.66,0,0,1,1.23-2.55A8,8,0,0,1,306.17,120.4Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.64,108.53a7.5,7.5,0,0,1,1.05,2.54,7.78,7.78,0,0,1,.56,2.69,7.51,7.51,0,0,1-1.06-2.54A7.36,7.36,0,0,1,305.64,108.53Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.85,116.73a4.93,4.93,0,0,1-2.19,0,4.78,4.78,0,0,1-2.15-.47,5,5,0,0,1,2.2,0A4.62,4.62,0,0,1,304.85,116.73Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.86,116a2.87,2.87,0,1,1-3.92-1.06A2.87,2.87,0,0,1,310.86,116Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.76,117.44c-.1.11-.66-.29-1.44-.37s-1.42.18-1.49.06.55-.68,1.54-.58S309.88,117.36,309.76,117.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.61,115.76c.12.09-.14.65-.26,1.37s-.09,1.33-.23,1.37-.44-.61-.28-1.46S308.5,115.67,308.61,115.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.84,101l-2.76-4.8-4.31.63-3.57-4.47L592,87.86l-4.81-3.2-3.59,3.63-4.73-.83L577,81.89l-5.75.61-.33,4.87-4.28,2.17-4.54-3.21-4.6,3.35,2.39,5.15L557.15,99l-5-.27-1.29,6.14,4.73,1.82.41,5.16-4.91,2.81,2.34,5.32,5.08-.79L561.9,123l-1.76,4.83,4.65,3.29,3.63-3.93,5,1.36,1.57,5.2,5.6-.37.72-4.67,4.8-2.76,3.93,3.13,5-3.7-2.51-4.37,2.45-4.38,5,.37,1.55-5.71L597.23,109l-.58-5.2Zm-19.5,16.8a11.32,11.32,0,1,1,4.18-15.45A11.31,11.31,0,0,1,581.34,117.76Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.72,104.65c-.05,0-.3-.44-1-1.1a6.07,6.07,0,0,0-3.48-1.66,5.76,5.76,0,1,0,4.59,8,6,6,0,0,0,.32-3.84c-.24-.9-.52-1.36-.47-1.39a1.51,1.51,0,0,1,.22.32,4.7,4.7,0,0,1,.44,1,5.93,5.93,0,0,1-.17,4,6.17,6.17,0,0,1-4.61,3.73,6.08,6.08,0,0,1-3.59-.43,6.15,6.15,0,0,1-3.67-6.39,6.09,6.09,0,0,1,1.44-3.32,6.17,6.17,0,0,1,5.55-2.1,6,6,0,0,1,3.57,1.89,4.69,4.69,0,0,1,.66.89A1.62,1.62,0,0,1,580.72,104.65Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.1,92.05a40.1,40.1,0,0,1-3.33,5.54,40.69,40.69,0,0,1-3.76,5.24,40.36,40.36,0,0,1,3.33-5.53A41.28,41.28,0,0,1,586.1,92.05Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.66,111.85c0,.15-2.34-.62-5.22-1.31s-5.26-1.09-5.25-1.24a18.09,18.09,0,0,1,5.37.73A18.4,18.4,0,0,1,591.66,111.85Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.06,113.16a17.6,17.6,0,0,1,1.49,4.58,17.46,17.46,0,0,1,.68,4.77,31.06,31.06,0,0,1-1.19-4.65A30.52,30.52,0,0,1,578.06,113.16Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572,112.47a20.55,20.55,0,0,1-2.15,4.06,19.7,19.7,0,0,1-2.59,3.79,20.55,20.55,0,0,1,2.15-4.06A19.7,19.7,0,0,1,572,112.47Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.08,93.18a19.61,19.61,0,0,1,1.56,4.17,20,20,0,0,1,1.06,4.33,19,19,0,0,1-1.56-4.17A19.18,19.18,0,0,1,571.08,93.18Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.8,106.5a11.87,11.87,0,0,1-3.55-.08,12.16,12.16,0,0,1-3.49-.59,24.57,24.57,0,0,1,7,.67Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.58,105.31a4.67,4.67,0,1,1-6.37-1.72A4.66,4.66,0,0,1,579.58,105.31Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.78,107.67a11.82,11.82,0,0,0-2.32-.77,12.28,12.28,0,0,0-2.44.25,2.73,2.73,0,0,1,2.49-.77C577.06,106.56,577.91,107.6,577.78,107.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.92,104.94c.12.08-.38,1-.59,2.19s-.07,2.22-.21,2.26a3,3,0,0,1-.31-2.36C575.05,105.69,575.81,104.84,575.92,104.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.09,329.09l-2.76-4.8-4.31.64-3.57-4.48,1.84-4.46-4.81-3.19-3.59,3.62-4.73-.83L220.24,310l-5.75.6-.33,4.87-4.28,2.18-4.54-3.21-4.6,3.35,2.39,5.15-2.73,4.12-5-.26-1.3,6.13,4.74,1.82.4,5.16-4.9,2.81,2.34,5.32,5.08-.79,3.36,3.89L203.38,356l4.66,3.28,3.63-3.93,5,1.37,1.57,5.19,5.6-.37.72-4.67,4.8-2.76,3.93,3.14,5-3.71-2.51-4.37,2.45-4.38,5,.37,1.55-5.71-4.33-2.34-.57-5.2Zm-19.5,16.8a11.32,11.32,0,1,1,4.18-15.45A11.32,11.32,0,0,1,224.59,345.89Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224,332.79c-.05,0-.3-.45-1-1.11a6.07,6.07,0,0,0-3.48-1.66,5.76,5.76,0,1,0,4.59,8,6.08,6.08,0,0,0,.32-3.85c-.24-.9-.52-1.36-.47-1.38a1.25,1.25,0,0,1,.22.31,5.25,5.25,0,0,1,.44,1,5.93,5.93,0,0,1-.17,4,6.18,6.18,0,0,1-8.2,3.31,6.28,6.28,0,0,1-2.9-2.6,6.17,6.17,0,0,1-.77-3.8,6.15,6.15,0,0,1,7-5.41,5.9,5.9,0,0,1,3.58,1.88,4.4,4.4,0,0,1,.66.9A1.24,1.24,0,0,1,224,332.79Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.35,320.19a40.36,40.36,0,0,1-3.33,5.53,40.69,40.69,0,0,1-3.76,5.24,80.28,80.28,0,0,1,7.09-10.77Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.91,340c-.06.14-2.34-.63-5.22-1.32s-5.27-1.09-5.25-1.24a18.12,18.12,0,0,1,5.37.73A17.86,17.86,0,0,1,234.91,340Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.31,341.3a17.06,17.06,0,0,1,1.48,4.57,17.3,17.3,0,0,1,.69,4.77,107.66,107.66,0,0,1-2.17-9.34Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.2,340.6a20.55,20.55,0,0,1-2.15,4.06,19.31,19.31,0,0,1-2.59,3.79,20.86,20.86,0,0,1,2.15-4.06A20.1,20.1,0,0,1,215.2,340.6Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.33,321.32a19.07,19.07,0,0,1,1.56,4.17,19.84,19.84,0,0,1,1.06,4.32,18.74,18.74,0,0,1-1.56-4.17A19.29,19.29,0,0,1,214.33,321.32Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.05,334.63a12.07,12.07,0,0,1-3.55-.07A12.36,12.36,0,0,1,206,334a24.57,24.57,0,0,1,7,.67Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.83,333.44a4.67,4.67,0,1,1-6.37-1.72A4.66,4.66,0,0,1,222.83,333.44Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221,335.8a11.82,11.82,0,0,0-2.32-.77,11.1,11.1,0,0,0-2.44.26,2.67,2.67,0,0,1,2.49-.77A2.71,2.71,0,0,1,221,335.8Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.16,333.07c.13.08-.38,1-.58,2.19s-.07,2.22-.22,2.26a3,3,0,0,1-.3-2.35C218.3,333.83,219.06,333,219.16,333.07Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M715.72,465.5c0,.14-153.16.26-342,.26s-342.09-.12-342.09-.26,153.13-.26,342.09-.26S715.72,465.35,715.72,465.5Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gears--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M445.13,241.36v-7.31l-5.36-2.11-1.14-7.46,5-3.9-3.41-6.82-6.5,1.79-4.87-4.06,1.47-7.63-7-3.08-3.58,5.35-6.33-.32-3.08-6.66-7.47.82-.65,7.46-5.84,2.92-5.52-3.57L385.39,213l4.22,5.2-2.92,6.16h-7.47l-.81,7.63,6.33,2.44L386,241l-5.19,4.39,3.16,6.82,6.74-2.12,4.87,4.87L394,262l6.66,3.25,3.9-4.87h7.3l2.44,6.17,8.11-1v-6.66l5.68-3.41,5.52,3.74,5.52-5.52-3.41-5.52,2.76-6.33Zm-33.36,6.41a14.94,14.94,0,1,1,14.93-14.93A14.93,14.93,0,0,1,411.77,247.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.67,232.37c-.06,0,0-.71-.35-1.91a7.83,7.83,0,0,0-2.88-4.22,7.71,7.71,0,0,0-3.25-1.42,7.81,7.81,0,0,0-4,.35,7.64,7.64,0,0,0-3.55,2.68,7.63,7.63,0,0,0,0,9,7.71,7.71,0,0,0,10.83,1.62,7.85,7.85,0,0,0,2.88-4.23c.32-1.2.29-1.91.35-1.9a1.91,1.91,0,0,1,0,.5,6,6,0,0,1-.17,1.45,7.84,7.84,0,0,1-2.86,4.47,8.09,8.09,0,0,1-11.46-1.6,8.1,8.1,0,0,1,0-9.64,8.06,8.06,0,0,1,3.8-2.83,8.18,8.18,0,0,1,4.27-.32,8,8,0,0,1,3.39,1.54,7.84,7.84,0,0,1,2.86,4.47,6,6,0,0,1,.17,1.45A2,2,0,0,1,419.67,232.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.11,221.48a70.88,70.88,0,0,1-7.48,4.07,69.3,69.3,0,0,1-7.72,3.6,69.52,69.52,0,0,1,7.48-4.06A70.59,70.59,0,0,1,434.11,221.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.46,247.8c-.12.1-2.21-2.31-5.06-5s-5.34-4.68-5.24-4.8a7.43,7.43,0,0,1,1.75,1.14,46.37,46.37,0,0,1,7.32,7A7.61,7.61,0,0,1,427.46,247.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411,240.36a43.9,43.9,0,0,1-3.66,12.12c-.14,0,.77-2.74,1.77-6.08A61.88,61.88,0,0,1,411,240.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.49,235.55a35.92,35.92,0,0,1-5.16,3.16,35,35,0,0,1-5.42,2.71,35.71,35.71,0,0,1,5.17-3.16A34.7,34.7,0,0,1,404.49,235.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.17,212.9a32.72,32.72,0,0,1-1,5.78,32.84,32.84,0,0,1-1.54,5.66,32.72,32.72,0,0,1,1-5.78A33.52,33.52,0,0,1,416.17,212.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406,227.3a21.1,21.1,0,0,1-4-2.48,22,22,0,0,1-3.66-2.91,20.41,20.41,0,0,1,4,2.48A21,21,0,0,1,406,227.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.93,232.37a6.16,6.16,0,1,1-6.16-6.16A6.16,6.16,0,0,1,417.93,232.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.33,233.89a10.75,10.75,0,0,0-2.11-2.48,10.34,10.34,0,0,0-3-1.24c0-.07.39-.16,1-.09a5,5,0,0,1,3.86,2.81C414.36,233.47,414.39,233.87,414.33,233.89Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414,229.53c.08.14-1.12.8-2.17,2.07s-1.52,2.55-1.67,2.5a5.64,5.64,0,0,1,3.84-4.57Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.38,154.29l-4.94-8.6-7.73,1.13-6.39-8,3.29-8L387,125.08l-6.44,6.5-8.48-1.49-3.44-10-10.31,1.09-.58,8.72-7.68,3.9-8.13-5.75-8.25,6,4.29,9.23-4.91,7.4-8.91-.48-2.33,11,8.48,3.26.73,9.24-8.79,5.05,4.2,9.54,9.1-1.42,6,7-3.15,8.68,8.34,5.89,6.5-7,9,2.44,2.81,9.32,10-.68,1.29-8.37,8.6-4.94,7,5.62,8.9-6.64-4.5-7.83,4.39-7.86,9,.66,2.77-10.23-7.75-4.19-1-9.33ZM376.43,184.4a20.28,20.28,0,1,1,7.49-27.69A20.29,20.29,0,0,1,376.43,184.4Z",
    style: {
      fill: "#089852"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.32,160.92a23.94,23.94,0,0,0-1.67-2,10.7,10.7,0,0,0-6.28-3.06,10.43,10.43,0,0,0-4.81.52A10.55,10.55,0,0,0,358,159.5a9.65,9.65,0,0,0-1.58,2.56,9.91,9.91,0,0,0-.81,3,10.43,10.43,0,0,0,6.16,10.73,10.62,10.62,0,0,0,6,.76,10.62,10.62,0,0,0,5-2.34,10.52,10.52,0,0,0,2.88-3.89,10.67,10.67,0,0,0,.51-7,26.18,26.18,0,0,0-.91-2.46,8.3,8.3,0,0,1,1.11,2.41,10.73,10.73,0,0,1-.37,7.16,10.92,10.92,0,0,1-2.94,4.08,11.05,11.05,0,0,1-5.22,2.48,10.68,10.68,0,0,1-3.15.1,10.31,10.31,0,0,1-3.17-.86A10.91,10.91,0,0,1,355.11,165a10.55,10.55,0,0,1,.86-3.17,10.15,10.15,0,0,1,1.68-2.67,10.81,10.81,0,0,1,9.77-3.74,10.68,10.68,0,0,1,6.37,3.29A8.53,8.53,0,0,1,375.32,160.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385,138.33c.12.08-2.62,4.47-6.14,9.8s-6.45,9.6-6.57,9.52,2.63-4.47,6.14-9.8S384.84,138.25,385,138.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.93,173.82a18.25,18.25,0,0,1-2.74-.75c-1.67-.51-4-1.18-6.58-1.81s-4.95-1.11-6.67-1.43a19.14,19.14,0,0,1-2.77-.58,12.87,12.87,0,0,1,2.83.22,67.36,67.36,0,0,1,6.74,1.28,66.23,66.23,0,0,1,6.57,2A13.48,13.48,0,0,1,394.93,173.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.55,176.17a11.9,11.9,0,0,1,.88,2.37c.46,1.49,1,3.56,1.58,5.88s.93,4.44,1.17,6a12,12,0,0,1,.26,2.52,12.68,12.68,0,0,1-.62-2.45c-.33-1.52-.78-3.62-1.32-5.93s-1.05-4.39-1.43-5.9A13.58,13.58,0,0,1,370.55,176.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.59,174.93a65.24,65.24,0,0,1-4,7.17,66.78,66.78,0,0,1-4.46,6.9,61.36,61.36,0,0,1,4-7.17A64.19,64.19,0,0,1,359.59,174.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358,140.36a61.44,61.44,0,0,1,2.59,7.53,60.46,60.46,0,0,1,2.1,7.69,60.94,60.94,0,0,1-2.6-7.54A61,61,0,0,1,358,140.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.74,164.23a38.83,38.83,0,0,1-6.34-.35,37.53,37.53,0,0,1-6.28-.86,38.7,38.7,0,0,1,6.33.35A37.77,37.77,0,0,1,355.74,164.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 366.01,
    cy: 166.26,
    r: 8.36,
    transform: "translate(-34.5 131.62) rotate(-19.49)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.06,166.32a11.8,11.8,0,0,0-4.15-1.58,11.49,11.49,0,0,0-4.4.66c0-.06.38-.4,1.17-.73a6.86,6.86,0,0,1,6.39.69C369.78,165.85,370.1,166.28,370.06,166.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.7,161.42a29.24,29.24,0,0,0-1.25,3.89,28.67,28.67,0,0,0-.18,4.09,6.7,6.7,0,0,1-.34-4.18A6.79,6.79,0,0,1,366.7,161.42Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.05,178.68l-1.7-3-2.65.39-2.2-2.76,1.13-2.74-3-2-2.21,2.23-2.91-.51L429.37,167l-3.54.37-.2,3L423,171.66l-2.79-2-2.83,2.06,1.47,3.17-1.69,2.54-3.06-.16-.8,3.77,2.91,1.12.25,3.17-3,1.74,1.44,3.27,3.12-.48,2.07,2.39-1.08,3,2.86,2,2.24-2.41,3.1.84,1,3.19,3.44-.23.45-2.87,2.95-1.7,2.42,1.93,3.05-2.28L438.93,191l1.5-2.69,3.1.22,1-3.51-2.66-1.44-.35-3.2Zm-12,10.34a7,7,0,1,1,2.57-9.51A7,7,0,0,1,432.05,189Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.67,181s-.21-.25-.62-.65a3.75,3.75,0,0,0-2.13-1,3.52,3.52,0,0,0-3.07,1.25,3.45,3.45,0,0,0-.34,3.92,3.47,3.47,0,0,0,6.18-.34,3.75,3.75,0,0,0,.23-2.33c-.13-.56-.3-.84-.25-.87a1.86,1.86,0,0,1,.44.81,3.63,3.63,0,0,1-.08,2.53,3.86,3.86,0,0,1-2.88,2.36,3.91,3.91,0,0,1-3.67-6.39A3.83,3.83,0,0,1,429,179a3.64,3.64,0,0,1,2.22,1.2A1.9,1.9,0,0,1,431.67,181Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435,173.2a15.23,15.23,0,0,1-2,3.46,15.09,15.09,0,0,1-2.4,3.17,15.47,15.47,0,0,1,2-3.46A15.09,15.09,0,0,1,435,173.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.4,185.39a17.7,17.7,0,0,1-3.24-.72,16,16,0,0,1-3.2-.86,8.22,8.22,0,0,1,3.32.35A8,8,0,0,1,438.4,185.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430,186.19a7.52,7.52,0,0,1,1,2.8,7.12,7.12,0,0,1,.32,2.95,10.75,10.75,0,0,1-.83-2.84A10.51,10.51,0,0,1,430,186.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.27,185.76a7.9,7.9,0,0,1-1.23,2.55,7.82,7.82,0,0,1-1.68,2.28,7.85,7.85,0,0,1,1.23-2.55A8,8,0,0,1,426.27,185.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.73,173.9a7.29,7.29,0,0,1,1.06,2.53,7.82,7.82,0,0,1,.56,2.69,7.29,7.29,0,0,1-1.06-2.53A7.82,7.82,0,0,1,425.73,173.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425,182.09a4.77,4.77,0,0,1-2.19,0,4.86,4.86,0,0,1-2.15-.46,4.61,4.61,0,0,1,2.19-.05A4.86,4.86,0,0,1,425,182.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431,181.36A2.87,2.87,0,1,1,427,180.3,2.87,2.87,0,0,1,431,181.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.86,182.81c-.1.11-.66-.3-1.44-.37s-1.42.18-1.49.05.55-.67,1.54-.57S430,182.73,429.86,182.81Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.71,181.13c.12.08-.14.64-.26,1.36s-.09,1.34-.23,1.38-.44-.62-.29-1.47S428.6,181,428.71,181.13Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M492.85,180s-3.4-1.19-3.44-3.42,25.45-5.41,30.32,7c0,0-1,.67-4.89.42",
    style: {
      fill: "#089852"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M492.85,180s-3.4-1.19-3.44-3.42,25.45-5.41,30.32,7c0,0-1,.67-4.89.42"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M514,216l-15.55-1.24c-.1-1.81,0-8.84,0-8.84s-6.47-1-6.55-7.47,1-21.33,1-21.33h0A22.48,22.48,0,0,1,515.57,180l1,.74Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.47,188.27a.94.94,0,1,0-1.26-1.39.93.93,0,0,0-.07,1.32A.94.94,0,0,0,494.47,188.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.9,186.79c.1.11.74-.38,1.63-.38s1.54.46,1.64.34-.06-.25-.34-.47a2.24,2.24,0,0,0-1.31-.41,2.17,2.17,0,0,0-1.29.45C493,186.54,492.85,186.74,492.9,186.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.17,187.57a.94.94,0,1,0,1.29.31A.94.94,0,0,0,503.17,187.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.58,187.58c.1.11.74-.38,1.63-.38s1.54.45,1.63.34,0-.26-.33-.47a2.22,2.22,0,0,0-2.61,0C502.63,187.32,502.53,187.53,502.58,187.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499,194.93a4.52,4.52,0,0,0-1.44-.31c-.24,0-.42-.08-.44-.2a1.3,1.3,0,0,1,.17-.67l.71-1.81a24.91,24.91,0,0,0,1.52-4.76,24.52,24.52,0,0,0-2,4.58l-.67,1.83a1.53,1.53,0,0,0-.12,1,.59.59,0,0,0,.4.37,2.08,2.08,0,0,0,.4,0A4.44,4.44,0,0,0,499,194.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.9,195.91a16.32,16.32,0,0,1-4.37,1.27,2.47,2.47,0,0,0,2.91,1C502.37,197.45,501.9,195.91,501.9,195.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.48,205.86a15,15,0,0,0,8.43-2.4s-2,4.66-8.45,4.07Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.85,178.78s3.78,2.19,9.08,0c3.48-1.43,7.45-2,8.26-1.22s.74,4.21,4,5.46c0,0-.71,6.58,1.93,6.54s1.76-10.38,1.76-10.38l-6.2-3.61-6.91-1.85-6.68.45-5.22,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.74,187.43c.11-.05,4.44-1.32,4.3,3.11s-4.55,3.37-4.56,3.24S515.74,187.43,515.74,187.43Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.89,192.15s.07,0,.2.12a.79.79,0,0,0,.58,0,1.9,1.9,0,0,0,.93-1.68,2.41,2.41,0,0,0-.18-1.12.85.85,0,0,0-.56-.6.38.38,0,0,0-.46.19c-.06.12,0,.21-.06.22s-.09-.08-.05-.26a.5.5,0,0,1,.18-.27.62.62,0,0,1,.43-.1,1.07,1.07,0,0,1,.78.71,2.53,2.53,0,0,1,.23,1.24,2,2,0,0,1-1.18,1.88.82.82,0,0,1-.7-.14C516.89,192.25,516.87,192.15,516.89,192.15Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.74,173.72c0,.15-.69.09-1.43.33s-1.24.64-1.35.54.3-.76,1.2-1S518.79,173.59,518.74,173.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.23,170.93a3,3,0,0,1,.14,2.11c-.24,1.2-1,1.91-1.09,1.81s.38-.85.58-1.92S516.07,170.94,516.23,170.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.23,185.34c-.14.26-1,0-2,0s-1.87.08-2-.19.76-.91,2-.85S497.39,185.1,497.23,185.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.16,185.34c-.14.26-1,0-2,0s-1.88.08-2-.19.75-.91,2-.85S507.31,185.1,507.16,185.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.41,175.66c-11.66-1.27-13.89.79-14,.89a2.46,2.46,0,0,1-.6-1.15c-.41-3.45,3.77-4.42,3.77-4.42,2.61-11.93,13.34-10.71,13.34-10.71v-.09a1.93,1.93,0,0,1,2.26-1.53l1.68.32a1.93,1.93,0,0,1,1.53,2.26h0c12.57,4.19,8.4,15.82,8.4,15.82l1.84,2.22c1.63,3.31-1.91,4.31-1.91,4.31S515.37,177,503.41,175.66Z",
    style: {
      fill: "#089852"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M509.28,171.59a26.26,26.26,0,0,1,.92-5.14,26,26,0,0,1,1.43-5,27,27,0,0,1-.92,5.13A26.57,26.57,0,0,1,509.28,171.59Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M503,170a24.89,24.89,0,0,1,1.13-4.94,24.28,24.28,0,0,1,1.63-4.79,24.72,24.72,0,0,1-1.13,4.93A24.54,24.54,0,0,1,503,170Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M493.1,171.48a4,4,0,0,1,1-.36,20.32,20.32,0,0,1,2.89-.57,27.19,27.19,0,0,1,9.67.62,35.07,35.07,0,0,1,9,3.64c1.08.61,1.92,1.16,2.49,1.56a4.27,4.27,0,0,1,.85.66c0,.08-1.34-.76-3.52-1.9a39.89,39.89,0,0,0-8.94-3.45,29.61,29.61,0,0,0-9.51-.76C494.6,171.14,493.12,171.58,493.1,171.48Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M508.72,173.7a6.41,6.41,0,0,1,2.07.39,23.41,23.41,0,0,1,8.86,4.83,6.74,6.74,0,0,1,1.46,1.52,62.42,62.42,0,0,0-5.88-4A60.93,60.93,0,0,0,508.72,173.7Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M510.61,162c-.13-.06,0-.6-.16-1.22s-.42-1.08-.31-1.19.67.28.82,1.09S510.73,162,510.61,162Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M518.71,175.32c-.72-.14-.46-3.53-2.26-6.88s-4.68-5.08-4.39-5.75c.12-.32,1.11-.32,2.49.35a9.94,9.94,0,0,1,5.28,10C519.6,174.59,519,175.4,518.71,175.32Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M425.35,258.54s-7.69-4-9-5.74-1.92-8.12-1.92-8.12l13.12,4.9Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.61,242c-.45.15-8.93,19.06-15.74,19.16s-41.52-2.65-41.52-2.65l2.16-9,33.29-1.07,10.91-14.77Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.77,457.89l1.55,6.47s10.59,13.76,13.85,13.09c2.14-.45-.49-4-4.52-14.48l-.84-4.32Z",
    style: {
      fill: "#089852"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.6,475.41a.59.59,0,0,1-.08.2,1.1,1.1,0,0,1-.44.41,1.7,1.7,0,0,1-1,.21,2.53,2.53,0,0,1-1.2-.44,50.87,50.87,0,0,1-5.33-5,68.8,68.8,0,0,1-4.74-5.55c-.56-.74-1-1.35-1.3-1.78l-.34-.5c-.07-.12-.11-.18-.1-.18l.14.15.36.48,1.36,1.74c1.16,1.46,2.81,3.44,4.77,5.49a59.13,59.13,0,0,0,5.26,5,2,2,0,0,0,2,.28A1.29,1.29,0,0,0,559.6,475.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.1,471s-.33,0-.85.05a5.19,5.19,0,0,0-1.91.72,3.89,3.89,0,0,0-1.43,1.43c-.25.46-.32.79-.35.78a1.76,1.76,0,0,1,.22-.85,3.66,3.66,0,0,1,1.45-1.54,4.51,4.51,0,0,1,2-.69A1.65,1.65,0,0,1,558.1,471Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.08,467.76s.11-.46.19-1.21a5,5,0,0,0-.53-2.84,4.71,4.71,0,0,0-2-2,8.75,8.75,0,0,0-1.15-.42,1.1,1.1,0,0,1,.34,0,3.29,3.29,0,0,1,.87.27,4.52,4.52,0,0,1,2.15,2.08,4.86,4.86,0,0,1,.49,2.95,5.62,5.62,0,0,1-.21.89A1,1,0,0,1,548.08,467.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.45,459a6.26,6.26,0,0,1,.59,2c.19,1.15.4,2.06.35,2.08a6.77,6.77,0,0,1-.56-2C544.63,459.91,544.4,459,544.45,459Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.84,463.88c0,.06-.6.05-1.31.21s-1.24.44-1.27.39a3.09,3.09,0,0,1,2.58-.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.06,465c0,.06-.51,0-1.1.15s-1,.41-1.05.36a1.58,1.58,0,0,1,1-.56A1.65,1.65,0,0,1,555.06,465Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.91,466.38a6.33,6.33,0,0,0-1.15,0,6.42,6.42,0,0,0-1,.46,1.35,1.35,0,0,1,1-.66A1.43,1.43,0,0,1,555.91,466.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.11,463.42a1.3,1.3,0,0,1-.35,0,7.07,7.07,0,0,1-.94-.26,8.34,8.34,0,0,1-1.32-.58,8.51,8.51,0,0,1-.73-.45,1.1,1.1,0,0,1-.53-.82.63.63,0,0,1,.81-.5,1.66,1.66,0,0,1,.74.49,12.37,12.37,0,0,1,1,1.06,8.87,8.87,0,0,1,.58.78,1.09,1.09,0,0,1,.18.31s-.33-.39-.87-1c-.27-.3-.6-.65-1-1A1.51,1.51,0,0,0,551,461c-.24-.07-.55.06-.56.31s.23.48.44.64a8.28,8.28,0,0,0,.71.45,9.7,9.7,0,0,0,1.27.62C553.63,463.28,554.12,463.38,554.11,463.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.56,463.28s0-.11,0-.32,0-.51.07-.88a4.74,4.74,0,0,1,.33-1.28,2.92,2.92,0,0,1,.42-.68.73.73,0,0,1,.85-.27.81.81,0,0,1,.29.85,2.93,2.93,0,0,1-.23.76,4.1,4.1,0,0,1-.76,1.09,5.25,5.25,0,0,1-.67.57.93.93,0,0,1-.28.16s.36-.29.85-.83a4.19,4.19,0,0,0,.68-1.07,2.78,2.78,0,0,0,.21-.71c0-.24,0-.53-.19-.63s-.44,0-.6.22a2.69,2.69,0,0,0-.39.62,4.71,4.71,0,0,0-.36,1.22A10.7,10.7,0,0,1,553.56,463.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M545.32,464.36l-.75-3.11s2.6.48,3.27,2.42a8.17,8.17,0,0,1,.5,3.33l5.65,6.07s1.41-2.76,4-2.1c0,0,2,4.44,2,5.55s-1.36,1-1.82.77a23.25,23.25,0,0,1-5.05-4A116.46,116.46,0,0,1,545.32,464.36Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M491.13,461.16l-.05-8.64,16.17-.19.21,12.63-1,.08c-4.46.3-22.7,1.22-25.7.35C477.42,464.42,491.13,461.16,491.13,461.16Z",
    style: {
      fill: "#089852"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M501.59,464.91a5.63,5.63,0,0,1,2-3.48,5.46,5.46,0,0,1,3.76-1.22l.06,4.52Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M484.43,463s-4.8,1.45-4.19,2.24,19.08.55,27.22-.27l0-.36-21.54.46S485.37,463,484.43,463Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.68,464.59a1.87,1.87,0,0,1-.27,0l-.8.06-2.94.16c-2.48.12-5.91.25-9.71.3s-7.22,0-9.71,0l-2.94-.09-.8,0-.28,0,.28,0h.8l2.95,0c2.48,0,5.91,0,9.7,0s7.22-.15,9.7-.24l2.94-.1.8,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.9,465.31a7.13,7.13,0,0,0-.57-1.4,6.36,6.36,0,0,0-1-1.11,2.21,2.21,0,0,1,1.19,1A2.17,2.17,0,0,1,485.9,465.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.64,462.83c-.05,0-.28-.25-.52-.62s-.4-.69-.35-.72.27.25.51.62A1.66,1.66,0,0,1,490.64,462.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.94,462.12s-.29-.13-.58-.38-.48-.48-.44-.52.29.13.57.38S492,462.08,491.94,462.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.75,460.58c0,.06-.38.11-.84.12s-.85,0-.85-.08a1.92,1.92,0,0,1,.84-.12A2,2,0,0,1,492.75,460.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493,459.5a1.63,1.63,0,0,1-.94.29,1.61,1.61,0,0,1-1-.12,4.73,4.73,0,0,1,.95-.08A6.11,6.11,0,0,1,493,459.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.07,461.42a2.71,2.71,0,0,1-1,0,6.11,6.11,0,0,1-1.11-.23,3.17,3.17,0,0,1-.63-.25.62.62,0,0,1-.27-.32.42.42,0,0,1,.16-.42,1.9,1.9,0,0,1,2.36.53,1.86,1.86,0,0,1,.35.69.67.67,0,0,1,0,.28,3,3,0,0,0-.49-.88,1.86,1.86,0,0,0-.89-.57,1.62,1.62,0,0,0-1.24.1c-.16.13-.1.32.09.43a3.47,3.47,0,0,0,.59.24,6.85,6.85,0,0,0,1.07.26C489.68,461.4,490.07,461.39,490.07,461.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.8,461.48a1.07,1.07,0,0,1-.13-.72A1.86,1.86,0,0,1,490,460a1.05,1.05,0,0,1,.86-.54.41.41,0,0,1,.32.48,1,1,0,0,1-.17.47,3,3,0,0,1-.48.63,1.54,1.54,0,0,1-.59.43s.21-.19.49-.52a3.62,3.62,0,0,0,.42-.63c.14-.22.24-.62,0-.66s-.53.24-.68.45a1.73,1.73,0,0,0-.29.68A5.47,5.47,0,0,0,489.8,461.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.3,460.17s-.47,0-1.2.05a5.08,5.08,0,0,0-4.19,3.43,11.87,11.87,0,0,0-.29,1.16s0-.11,0-.32a4.4,4.4,0,0,1,.17-.88,4.88,4.88,0,0,1,4.31-3.52,3.63,3.63,0,0,1,.89,0C507.19,460.12,507.3,460.15,507.3,460.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.53,453.46a26.37,26.37,0,0,1,.19,3.32,27.47,27.47,0,0,1,0,3.32,30.67,30.67,0,0,1-.18-3.32A28.9,28.9,0,0,1,505.53,453.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.54,463.35a8.8,8.8,0,0,1-2.36.27,9.28,9.28,0,0,1-2.37-.16c0-.06,1.06,0,2.36,0S499.53,463.3,499.54,463.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.71,463.31s-.09.22-.19.47-.16.46-.22.45-.08-.25,0-.53S502.67,463.27,502.71,463.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.88,461.81s-.06.2-.23.38-.33.28-.36.24.06-.21.22-.38S503.84,461.77,503.88,461.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.58,461.11c0,.05-.22.05-.46.14s-.4.21-.45.18.09-.26.39-.37S505.6,461.06,505.58,461.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.8,460.77c0,.05-.07.13-.21.19s-.26.05-.28,0,.08-.13.21-.18S506.78,460.72,506.8,460.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529,292l-48.85,2.77C480,289.39,482,246.3,482,246.3l-2.69,5-14-12.47,12.22-16.51a24.2,24.2,0,0,1,16.18-9.57c1.9-.26,3.34-.38,4.27-.5a27.54,27.54,0,0,0,16.59,0h0a22.48,22.48,0,0,1,6.86,1.32,28.27,28.27,0,0,1,11,7.09h0l14.63,24.58-17.74,11.16-2.56-7.73Z",
    style: {
      fill: "#089852"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "480.12 289.65 487.67 457.44 512.86 457.97 508.68 317.5 537.01 459.04 560.96 459.04 528.97 289.65",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "535.76 456.76 536.34 459.24 560.96 459.57 560.59 455.69 535.76 456.76",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.51,456.5c.15,0,.28.33.3.74s-.08.75-.22.76-.28-.32-.3-.73S508.37,456.51,508.51,456.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.27,450.43c.14,0,.28.67.31,1.51s-.06,1.52-.2,1.53-.29-.67-.32-1.51S508.12,450.43,508.27,450.43Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.08,444.35c.15,0,.28.67.31,1.51s-.08,1.53-.22,1.53-.28-.67-.3-1.51S507.94,444.35,508.08,444.35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.93,438.27c.15,0,.28.67.3,1.51s-.08,1.53-.22,1.53-.28-.68-.3-1.52S507.79,438.27,507.93,438.27Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.79,432.18c.14,0,.27.68.3,1.52s-.08,1.52-.23,1.53-.27-.68-.3-1.52S507.64,432.19,507.79,432.18Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.62,426.1c.14,0,.28.67.3,1.51s-.07,1.52-.21,1.53-.28-.67-.31-1.52S507.47,426.1,507.62,426.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.38,420c.14,0,.29.66.33,1.5s-.06,1.53-.2,1.53-.29-.66-.32-1.5S507.24,420,507.38,420Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.13,413.94c.15,0,.29.67.32,1.51s-.05,1.52-.2,1.53-.28-.67-.32-1.51S507,413.94,507.13,413.94Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.91,407.86c.15,0,.29.67.32,1.51s-.07,1.52-.21,1.53-.28-.67-.31-1.51S506.77,407.86,506.91,407.86Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.72,401.77c.14,0,.28.68.31,1.52s-.07,1.52-.22,1.53-.28-.68-.3-1.52S506.58,401.78,506.72,401.77Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.56,395.7c.14,0,.27.67.3,1.51s-.08,1.52-.23,1.53-.27-.68-.29-1.52S506.41,395.7,506.56,395.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.42,389.61c.15,0,.28.68.3,1.52s-.09,1.52-.23,1.52-.28-.67-.29-1.51S506.28,389.62,506.42,389.61Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.32,383.53c.15,0,.27.68.29,1.52s-.1,1.52-.24,1.52-.27-.67-.28-1.51S506.18,383.53,506.32,383.53Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.25,377.45c.15,0,.27.68.28,1.52s-.1,1.52-.25,1.52-.26-.68-.27-1.52S506.11,377.45,506.25,377.45Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.21,371.36c.15,0,.27.68.27,1.52s-.11,1.52-.25,1.53-.26-.68-.27-1.52S506.07,371.36,506.21,371.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.21,365.28c.14,0,.26.68.26,1.52s-.12,1.52-.26,1.52-.26-.68-.26-1.52S506.07,365.28,506.21,365.28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.24,359.2c.14,0,.25.68.25,1.52s-.13,1.52-.27,1.52-.26-.68-.25-1.52S506.1,359.2,506.24,359.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.3,353.11c.14,0,.25.69.24,1.53s-.13,1.52-.27,1.51-.26-.68-.25-1.52S506.16,353.11,506.3,353.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.4,347c.14,0,.24.69.23,1.53s-.14,1.51-.29,1.51-.24-.68-.23-1.52S506.25,347,506.4,347Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.52,341c.14,0,.25.68.23,1.52s-.15,1.52-.3,1.52-.24-.69-.22-1.53S506.38,340.94,506.52,341Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.71,334.86c.14,0,.23.69.2,1.53s-.16,1.52-.31,1.51-.24-.69-.21-1.53S506.56,334.85,506.71,334.86Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507,328.78c.14,0,.22.7.17,1.53s-.21,1.52-.35,1.51-.22-.7-.17-1.54S506.89,328.77,507,328.78Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.56,322.72c.15,0,.2.7.11,1.54s-.26,1.5-.4,1.49-.2-.7-.11-1.54S507.42,322.7,507.56,322.72Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.14,318.22c.14,0,.21.37.15.78s-.22.72-.36.7-.21-.36-.15-.78S508,318.2,508.14,318.22Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "487.01 458.25 513.65 458.69 513.44 454.25 487.01 454.39 487.01 458.25",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "516.84 294.75 514.16 243.49 484.78 243.49 480.02 296.21 516.84 294.75",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.21,214.28s-11.9,3.12-12.1,31.07h-4.8s-1.26-23.47,11.69-32.69C518,212.66,521.74,211.76,523.21,214.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498,212.29s-8.45,4-8.65,32h-4.08S485,218.07,493,212.91A5.68,5.68,0,0,1,498,212.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.94,454.33c.14,0,.31.29.38.7s0,.75-.14.78-.31-.29-.38-.7S555.8,454.35,555.94,454.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555,448.5c.14,0,.36.61.49,1.41s.13,1.48,0,1.5-.36-.61-.49-1.41S554.84,448.52,555,448.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554,442.66c.15,0,.37.61.5,1.42s.13,1.48,0,1.5-.37-.61-.5-1.42S553.88,442.69,554,442.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.05,436.84c.14,0,.37.6.5,1.41s.13,1.48,0,1.5-.37-.61-.5-1.41S552.91,436.86,553.05,436.84Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.07,431c.14,0,.37.61.5,1.41s.14,1.48,0,1.5-.36-.61-.5-1.41S551.93,431,552.07,431Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.08,425.18c.14,0,.37.61.51,1.41s.13,1.48,0,1.5-.37-.6-.51-1.41S550.94,425.21,551.08,425.18Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.08,419.36c.15,0,.37.61.51,1.41s.14,1.47,0,1.5-.36-.61-.5-1.41S549.94,419.38,550.08,419.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.08,413.53c.14,0,.37.61.5,1.42s.14,1.47,0,1.5-.37-.61-.51-1.42S548.93,413.56,549.08,413.53Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.06,407.71c.14,0,.37.61.51,1.41s.14,1.48,0,1.5-.37-.6-.51-1.41S547.92,407.74,548.06,407.71Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547,401.89c.14,0,.37.61.52,1.41s.14,1.48,0,1.5-.37-.6-.52-1.41S546.89,401.92,547,401.89Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546,396.08c.14,0,.37.6.51,1.4s.15,1.48,0,1.5-.38-.6-.52-1.4S545.86,396.1,546,396.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545,390.26c.14,0,.38.6.52,1.41s.15,1.47,0,1.5-.38-.61-.52-1.41S544.81,390.28,545,390.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.9,384.44c.14,0,.37.61.52,1.41s.15,1.48,0,1.5-.38-.6-.52-1.41S543.76,384.47,543.9,384.44Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.84,378.63c.14,0,.37.6.52,1.41s.15,1.47,0,1.5-.38-.61-.52-1.41S542.7,378.66,542.84,378.63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.77,372.82c.14,0,.37.6.52,1.4s.15,1.48,0,1.5-.37-.6-.52-1.4S541.62,372.84,541.77,372.82Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.68,367c.15,0,.38.6.53,1.4s.16,1.48,0,1.5-.38-.6-.53-1.4S540.54,367,540.68,367Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.6,361.2c.14,0,.37.6.52,1.4s.16,1.48,0,1.5-.38-.6-.53-1.4S539.45,361.23,539.6,361.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.5,355.39c.14,0,.38.61.53,1.41s.16,1.47,0,1.5-.38-.6-.53-1.41S538.36,355.42,538.5,355.39Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.39,349.59c.14,0,.38.6.53,1.4s.17,1.47,0,1.5-.38-.6-.53-1.4S537.25,349.62,537.39,349.59Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.27,343.79c.14,0,.38.6.54,1.4s.16,1.47,0,1.5-.38-.6-.53-1.4S536.13,343.81,536.27,343.79Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.15,338c.14,0,.38.59.53,1.4s.17,1.47,0,1.5-.38-.6-.54-1.4S535,338,535.15,338Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534,332.19c.14,0,.38.59.54,1.4s.17,1.47,0,1.5-.38-.6-.54-1.4S533.87,332.21,534,332.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.87,326.39c.14,0,.38.6.54,1.4s.17,1.47,0,1.5-.38-.6-.54-1.4S532.73,326.42,532.87,326.39Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.71,320.59c.15,0,.39.6.55,1.4s.17,1.47,0,1.5-.38-.6-.54-1.4S531.57,320.62,531.71,320.59Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.55,314.8c.14,0,.39.6.55,1.4s.18,1.47,0,1.49-.38-.59-.54-1.39S530.41,314.83,530.55,314.8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.38,309c.14,0,.39.59.55,1.39s.18,1.47,0,1.5-.39-.59-.55-1.39S529.24,309,529.38,309Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.49,304.64c.14,0,.32.28.41.68s0,.76-.11.79-.32-.28-.4-.68S528.35,304.67,528.49,304.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.52,242.82a3.23,3.23,0,0,1,.25,1.48,3.6,3.6,0,0,1-.34,1.66,2.34,2.34,0,0,1-1.65,1.33,2.13,2.13,0,0,1-2-.8,2.63,2.63,0,0,1-.59-1.61c0-1,.3-1.5.35-1.47s-.08.58,0,1.44a2.42,2.42,0,0,0,.58,1.33,1.74,1.74,0,0,0,1.53.6,2,2,0,0,0,1.31-1,3.79,3.79,0,0,0,.39-1.45C489.46,243.4,489.43,242.82,489.52,242.82Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.39,243.55c0-.06.3-.19.65.12a.84.84,0,0,1-.46,1.45.86.86,0,0,1-.92-.39.85.85,0,0,1,0-.79c.21-.42.56-.42.55-.35s-.16.19-.2.47a.44.44,0,1,0,.78-.15C487.61,243.67,487.4,243.63,487.39,243.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.79,243a2.74,2.74,0,0,1,.2,1.4,3.26,3.26,0,0,1-.42,1.55,2.07,2.07,0,0,1-1.7,1.05,2.56,2.56,0,0,1-1.87-.69,3,3,0,0,1-.81-1.38c-.24-.88-.1-1.43,0-1.43s.09.55.38,1.31a3,3,0,0,0,.79,1.14,2.2,2.2,0,0,0,1.52.53,1.65,1.65,0,0,0,1.33-.79,3.24,3.24,0,0,0,.45-1.32A6.31,6.31,0,0,1,510.79,243Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.49,243.54c0-.06.26-.14.52.14a.7.7,0,0,1,.17.63.78.78,0,0,1-1.39.23.73.73,0,0,1-.05-.65c.15-.35.44-.36.44-.29s-.08.18-.08.39.11.4.37.36.31-.26.24-.47S508.49,243.62,508.49,243.54Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.67,255.93s-.22.2-.69.49a22,22,0,0,1-2,1.07,30.57,30.57,0,0,1-7.18,2.32,30.19,30.19,0,0,1-7.54.48A19.65,19.65,0,0,1,490,260a2.88,2.88,0,0,1-.82-.19c0-.09,1.19,0,3.11.08a37.62,37.62,0,0,0,7.42-.63,36.73,36.73,0,0,0,7.13-2.15C508.58,256.42,509.63,255.86,509.67,255.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "532.89 300.85 479.34 296.21 479.34 302.31 532.89 306.87 532.89 300.85",
    style: {
      fill: "#089852"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.24,297.42a17.89,17.89,0,0,1-2.23-.06c-1.38-.08-3.3-.19-5.56-.36l.25-.27,1.09,6.11.08.49-.24-.21,7.11.46-.23.23c-.12-1.87-.19-3.45-.24-4.57a17,17,0,0,1,0-1.82,11.51,11.51,0,0,1,.24,1.68c.12,1.1.29,2.72.47,4.68l0,.25-.25,0-7.12-.37-.21,0,0-.2-.09-.49-1-6.12-.05-.3.3,0c2.35.22,4.32.44,5.68.6A17,17,0,0,1,496.24,297.42Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486,298.69a8.53,8.53,0,0,1,3-.06,8.8,8.8,0,0,1,2.95.46,8.5,8.5,0,0,1-3,.06A8.8,8.8,0,0,1,486,298.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.64,300.44a9.72,9.72,0,0,1,3.19.05,10,10,0,0,1,3.14.57,9.75,9.75,0,0,1-3.19-.05A10,10,0,0,1,485.64,300.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.87,244.71,406.05,238l-.78,2.54s7.75,12.21,16.78,14.73Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.79,280.21s-30.6-21.47-32.44-22.12-15-.68-18.25-.33-12.71-.61-12.71-.61l9.71-26.94-20.63-5.29,1.09-3.68s16.6-10,26.19-7.12,14.09,15.44,16.08,18.55,6.32,14.26,26.81,27.36l12.11,8.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.78,236.83a3.08,3.08,0,0,1-.12.31l-.36.84-1.37,3.18-5,11.46-.2-.27a25.68,25.68,0,0,1,3.52,0,10,10,0,0,1,3.72.77c2.29,1.29,4.52,2.85,6.91,4.45,4.75,3.23,9.88,6.82,15.23,10.61a4.58,4.58,0,0,0,2.23,1.07,3.7,3.7,0,0,0,4.13-4.5,3.76,3.76,0,0,0-1.16-2c-.6-.48-1.31-.95-1.95-1.41l-3.83-2.73-13.23-9.48a11.19,11.19,0,0,1-2.36-2.35c-.65-.83-1.21-1.64-1.72-2.41-1-1.53-1.85-2.89-2.5-4s-1.15-2-1.47-2.6l-.36-.68a2.64,2.64,0,0,1-.11-.25.87.87,0,0,1,.16.22l.4.66,1.55,2.55c.68,1.1,1.53,2.44,2.57,4,.52.75,1.09,1.55,1.74,2.36a10.4,10.4,0,0,0,2.32,2.26l13.29,9.39,3.84,2.71c.66.48,1.31.9,2,1.44a4.22,4.22,0,0,1-3.37,7.36,5,5,0,0,1-2.46-1.17c-5.35-3.78-10.47-7.38-15.2-10.63-2.37-1.6-4.63-3.19-6.84-4.45a9.66,9.66,0,0,0-3.55-.76,28.3,28.3,0,0,0-3.45,0l-.33,0,.13-.3c2.22-4.82,4-8.75,5.29-11.51.61-1.31,1.08-2.34,1.43-3.08l.37-.79C451.74,236.91,451.78,236.82,451.78,236.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.22,304.75h0A9,9,0,0,1,518.36,307l-40.83-31.88,7.25-12.34,44.1,29.55A9,9,0,0,1,531.22,304.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "441.56 235.1 437.88 246.58 431.15 246.61 435.33 235.14 441.56 235.1",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.72,244.06c0-.29,2.22-.53,4.95-.55s5,.21,5,.5-2.21.53-4.95.55S430.72,244.35,430.72,244.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432,240.4c0-.29,2.22-.54,5-.55s5,.21,5,.5-2.22.53-5,.54S432,240.68,432,240.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.8,236.9c0-.29,2.21-.53,4.95-.55s5,.21,5,.5-2.22.53-4.95.54S432.8,237.19,432.8,236.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426,243.42a25.29,25.29,0,0,1-1.64,6,31.47,31.47,0,0,1-2.45,5.69,45.08,45.08,0,0,1,2-5.87C425,246,425.84,243.39,426,243.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.05,268.94c.09-7.54-8-22.4-8-22.4l-14.48,9.1,2.35,6.15-32.4,13.33-8.86.41L486,283.65l7.28,6.68,19-5.25C524.3,283,552.94,277.3,553.05,268.94Z",
    style: {
      fill: "#ffbe9d"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.82,313.58l4-7.63-14.24-7.66-6,11.1.86.53c3.81,2.33,19.55,11.59,22.61,12.21C275.46,322.82,264.82,313.58,264.82,313.58Z",
    style: {
      fill: "#089852"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M253.81,312.05a5.61,5.61,0,0,0-.18-4,5.45,5.45,0,0,0-2.78-2.83l-2.14,4Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M269.9,318.31s3.59,3.5,2.68,3.92-17.16-8.35-24-12.84l.2-.31,18.88,10.38S269.06,317.9,269.9,318.31Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.56,309l.23.16.68.42L252,311c2.14,1.25,5.13,2.95,8.46,4.75s6.4,3.37,8.63,4.47l2.64,1.29.73.34a1,1,0,0,0,.26.1l-.25-.14-.7-.37-2.62-1.34c-2.21-1.14-5.26-2.72-8.59-4.52s-6.33-3.48-8.49-4.7l-2.56-1.45-.7-.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.53,319.68a7.22,7.22,0,0,1,1.15-1,6.65,6.65,0,0,1,1.42-.52,2.16,2.16,0,0,0-1.52.35A2.25,2.25,0,0,0,267.53,319.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.48,315.29a1.76,1.76,0,0,0,.74-.31c.39-.21.68-.43.65-.47s-.36.09-.74.3S264.45,315.24,264.48,315.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.66,314.05c0,.06.31,0,.68-.06s.65-.2.63-.25-.31,0-.68.06S263.64,314,263.66,314.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.65,312.32c0,.05.29.27.69.49a2,2,0,0,0,.79.33c0-.05-.28-.27-.69-.5S263.68,312.27,263.65,312.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.91,311.24s.24.39.7.68a1.62,1.62,0,0,0,.92.35,5.09,5.09,0,0,0-.81-.51A4.9,4.9,0,0,0,263.91,311.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.63,314.3a3.1,3.1,0,0,0,.92.49,6,6,0,0,0,1.09.31,2.9,2.9,0,0,0,.68.07.54.54,0,0,0,.38-.16.42.42,0,0,0,.06-.44,1.9,1.9,0,0,0-2.34-.63,2.18,2.18,0,0,0-.63.45c-.12.14-.16.23-.15.24a2.74,2.74,0,0,1,.83-.56,1.93,1.93,0,0,1,1.06-.09,1.6,1.6,0,0,1,1.05.67c.09.18-.06.32-.27.33a2.78,2.78,0,0,1-.64-.06,6.22,6.22,0,0,1-1.07-.26C266,314.46,265.65,314.28,265.63,314.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.85,314.48a1.15,1.15,0,0,0,.44-.58,1.58,1.58,0,0,0,.11-.8,1,1,0,0,0-.51-.88.42.42,0,0,0-.51.27,1.07,1.07,0,0,0-.06.49,3.42,3.42,0,0,0,.13.79,1.54,1.54,0,0,0,.33.65s-.1-.26-.19-.69a3.28,3.28,0,0,1-.09-.75c0-.26.08-.66.33-.58a1,1,0,0,1,.39.72,1.57,1.57,0,0,1-.06.73A5.48,5.48,0,0,1,265.85,314.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251,305.21s.43.18,1,.61a5.18,5.18,0,0,1,1.79,2.18,5.26,5.26,0,0,1,.34,2.8,11.39,11.39,0,0,1-.28,1.16s.07-.09.16-.29a4.91,4.91,0,0,0,.26-.85,5,5,0,0,0-.3-2.9,5.08,5.08,0,0,0-1.89-2.22,4.19,4.19,0,0,0-.8-.4A1.13,1.13,0,0,0,251,305.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.62,300.08a26.4,26.4,0,0,0-1.7,2.86,28.53,28.53,0,0,0-1.53,2.95,26.4,26.4,0,0,0,1.7-2.86A27.41,27.41,0,0,0,255.62,300.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.35,311.63a13.11,13.11,0,0,0,4.14,2.28c0-.05-.94-.49-2.08-1.12S256.38,311.59,256.35,311.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.56,310.12c-.05,0,0,.24-.05.51s-.07.48,0,.5.2-.18.22-.49S253.61,310.11,253.56,310.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.21,308.25c-.05,0,0,.21,0,.44s.16.4.22.39,0-.22,0-.45S253.27,308.23,253.21,308.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252,306.84c0,.05.18.15.34.34s.27.38.32.37,0-.28-.17-.5S252,306.79,252,306.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.11,306s0,.15.1.26.2.17.24.14,0-.16-.09-.27S251.15,305.94,251.11,306Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.26,
    y: 311.86,
    width: 36.07,
    height: 7.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.78,
    y: 359.37,
    width: 36.07,
    height: 7.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.96,
    y: 401.49,
    width: 43.36,
    height: 7.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.18,
    y: 262.73,
    width: 30.68,
    height: 7.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.87,
    y: 213.68,
    width: 30.68,
    height: 7.25,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "277.14 164.9 178.28 465.71 187.69 465.71 280.43 185.61 350.58 465.71 361.88 465.71 286.08 164.9 277.14 164.9",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "300.2 164.9 223.47 465.71 238.06 465.71 306.32 186.08 398.59 465.71 411.48 465.71 310.85 164.9 300.2 164.9",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.27,365.69h0a3.62,3.62,0,0,0,3.62,3.63h32.76a3.62,3.62,0,0,0,3.62-3.63h0a3.62,3.62,0,0,0-3.62-3.62H218.89A3.62,3.62,0,0,0,215.27,365.69Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201,412.36h0a3.63,3.63,0,0,0,3.63,3.62h32.75a3.62,3.62,0,0,0,3.63-3.62h0a3.63,3.63,0,0,0-3.63-3.63H204.58A3.64,3.64,0,0,0,201,412.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231,317.62h0a3.62,3.62,0,0,0,3.62,3.62h32.76a3.62,3.62,0,0,0,3.62-3.62h0a3.62,3.62,0,0,0-3.62-3.62H234.65A3.62,3.62,0,0,0,231,317.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.87,
    y: 264.2,
    width: 37.91,
    height: 7.25,
    rx: 3.62,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.64,218.56h0a3.63,3.63,0,0,0,3.62,3.63H288.7a3.63,3.63,0,0,0,3.62-3.63h0a3.62,3.62,0,0,0-3.62-3.62H265.26A3.62,3.62,0,0,0,261.64,218.56Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.31,144.35c.46.15,8.93,19.06,15.74,19.16s41.53-2.65,41.53-2.65l.42-10.13-35.87.1-10.91-14.77Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.6,152s5.92-1.9,6.57-2.83,3.32-5.3,3.32-5.3a3.54,3.54,0,0,1,.66,2.62c-.19.72-.52,2-.76,3a.86.86,0,0,0,1,1.06c1.4-.25,3.45-.5,3.69.17.38,1-1.25,7.64-2.44,8.86s-9.33,1.24-9.33,1.24Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.57,152.67c0,.05-.37.44-1.2.83a5.82,5.82,0,0,1-1.55.47,1.59,1.59,0,0,1-1.05-.2,1.09,1.09,0,0,1-.44-1.12,1.57,1.57,0,0,1,.62-1,2.73,2.73,0,0,1,.91-.41c.58-.16,1.09-.25,1.53-.34a3.91,3.91,0,0,1,1.43-.18,3.86,3.86,0,0,1-1.34.53l-1.48.45a1.46,1.46,0,0,0-1.16,1c-.11.55.4.81.94.75a6.9,6.9,0,0,0,1.45-.33A8.93,8.93,0,0,1,334.57,152.67Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.59,155.67a2.85,2.85,0,0,1-1,.53,2.52,2.52,0,0,1-.59.15.94.94,0,0,1-.75-.28,1.32,1.32,0,0,1-.3-1.65,2.48,2.48,0,0,1,1.33-.9l1.12-.45c.65-.26,1.08-.33,1.1-.26s-.35.26-.95.59c-.3.17-.66.36-1.08.56a2.33,2.33,0,0,0-1.08.73.86.86,0,0,0,.19,1,.47.47,0,0,0,.4.19,2.84,2.84,0,0,0,.51-.06C333.13,155.68,333.57,155.58,333.59,155.67Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330,157.86c-.07,0-.19-.34-.5-.84a4.42,4.42,0,0,0-1.67-1.58l-.33-.18.3-.25c.2-.17.42-.35.62-.55a13.27,13.27,0,0,0,2.28-3.5c.07,0,0,.51-.23,1.27a7.06,7.06,0,0,1-1.69,2.6,5.91,5.91,0,0,1-.67.58l0-.42a4,4,0,0,1,1.72,1.87C330,157.46,330,157.85,330,157.86Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.74,158c0,.06-.26.33-.89.55a1.54,1.54,0,0,1-1.22-.06,1.35,1.35,0,0,1-.56-.53,1,1,0,0,1,0-.9,2.52,2.52,0,0,1,1.11-1,9.51,9.51,0,0,1,1-.47c.59-.23,1-.29,1-.22s-.32.25-.85.55c-.26.16-.58.34-.92.56a2.54,2.54,0,0,0-.88.76c-.15.29.07.62.35.79a1.31,1.31,0,0,0,.9.13C333.33,158.07,333.71,157.92,333.74,158Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.55,91.55a22,22,0,0,1-1,5.22,7.62,7.62,0,0,1-3.23,4.11c-1.48.83-3.52,1.18-4.09,2.78s.67,3.66-.5,4.86a3.74,3.74,0,0,1-1.82.78,8,8,0,0,0-5.2,4,8.61,8.61,0,0,0,.52,7.55,25.67,25.67,0,0,0,5,6l19-4.07s-5.62-30.13-5.53-29.92A24.1,24.1,0,0,1,233.55,91.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.75,93.14a3.25,3.25,0,0,0,1.62,2.22,22.8,22.8,0,0,1,2.42,1.5,6,6,0,0,1,1.89,4.56,17.9,17.9,0,0,1-.9,5,10.71,10.71,0,0,1,8,4.17,14,14,0,0,1,2.82,8.69c0,2.22-.56,4.62-2.26,6a9.51,9.51,0,0,1-4.87,1.73c-3.45.51-6.92.81-10.39,1.11s-7.21.54-10.29-1.13a12.89,12.89,0,0,1-5.42-6.67,27.51,27.51,0,0,1-1.61-12.79,61.45,61.45,0,0,1,2.81-12.68",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.82,88.26a13.44,13.44,0,0,0-5.43-1.45c-1.89,0-3.89,1.12-4.41,2.94a4.27,4.27,0,0,0,.34,2.93,8.79,8.79,0,0,0,1.8,2.4,4.42,4.42,0,0,0,2.57,1.51,3.75,3.75,0,0,0,2.23-.63,5.85,5.85,0,0,0,2.7-3.47,4.08,4.08,0,0,0-1.24-4.09",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.44,84s3.41-1.19,3.44-3.42-25.45-5.41-30.32,7c0,0,.95.67,4.89.42",
    style: {
      fill: "#089852"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M256.44,84s3.41-1.19,3.44-3.42-25.45-5.41-30.32,7c0,0,.95.67,4.89.42"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M236.92,118.35l15.55-1.24c.1-1.81,0-8.84,0-8.84s6.47-1,6.55-7.47-1-21.33-1-21.33h0a22.5,22.5,0,0,0-22.6,2.84l-1,.74Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.34,90.24a.94.94,0,1,1,1.26-1.39.94.94,0,1,1-1.26,1.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258,89.11c-.1.11-.73-.37-1.62-.38s-1.54.46-1.64.34.05-.25.34-.46a2.14,2.14,0,0,1,1.3-.42,2.18,2.18,0,0,1,1.3.45C258,88.86,258.07,89.06,258,89.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.93,89.59a.94.94,0,0,1-1,1.6,1,1,0,0,1-.31-1.3A.93.93,0,0,1,246.93,89.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.35,89.9c-.11.11-.74-.38-1.63-.38s-1.54.45-1.64.34.06-.25.34-.47a2.15,2.15,0,0,1,1.31-.41,2.17,2.17,0,0,1,1.29.44C248.3,89.64,248.4,89.85,248.35,89.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.92,97.25a4.33,4.33,0,0,1,1.44-.31c.23,0,.42-.07.43-.2a1.26,1.26,0,0,0-.16-.67c-.23-.59-.47-1.18-.71-1.81a24.91,24.91,0,0,1-1.52-4.76,25.32,25.32,0,0,1,2,4.58c.23.63.45,1.23.66,1.83a1.46,1.46,0,0,1,.13,1,.61.61,0,0,1-.4.37,1.24,1.24,0,0,1-.4,0A4.44,4.44,0,0,1,251.92,97.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.45,108.18a15.08,15.08,0,0,1-8.44-2.4s2,4.66,8.45,4.07Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.08,81.1a10.79,10.79,0,0,1-9.08,0c-3.48-1.43-7.45-2-8.26-1.22s.6,7.45-2.65,8.71c0,0-.62,3.33-3.27,3.29s-1.75-10.37-1.75-10.37l6.19-3.62,6.92-1.84,6.68.44,5.22,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.19,89.75c-.11,0-4.45-1.31-4.3,3.11s4.55,3.37,4.55,3.24S235.19,89.75,235.19,89.75Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234,94.47s-.08,0-.21.12a.76.76,0,0,1-.57,0,1.93,1.93,0,0,1-.94-1.68,2.62,2.62,0,0,1,.18-1.11.91.91,0,0,1,.56-.61.37.37,0,0,1,.46.19c.07.12,0,.21.07.22s.09-.08,0-.26a.47.47,0,0,0-.19-.27A.59.59,0,0,0,233,91a1.1,1.1,0,0,0-.78.71A2.77,2.77,0,0,0,232,93a2,2,0,0,0,1.19,1.88.83.83,0,0,0,.7-.14C234,94.57,234.05,94.48,234,94.47Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.19,76c-.06-.13.68-.45,1.58-.17s1.32,1,1.2,1-.62-.32-1.36-.54S232.22,76.19,232.19,76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.7,73.25c.16,0,.16.94.37,2s.69,1.83.57,1.92-.85-.61-1.08-1.81A3,3,0,0,1,234.7,73.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.69,87.66c-.15-.24.67-1,2-1s2.17.6,2,.85-1,.14-2,.19S253.84,87.92,253.69,87.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.61,79.74a31.35,31.35,0,0,1,3.84,2.89,6.72,6.72,0,0,0,4.43,1.62l-.39-.75a26.74,26.74,0,0,0,7.32,1.77,2.84,2.84,0,0,0,2.59-.68c.58-.75-.23-2.09-.32-3.49-.07-1-.42-1.27-1.37-1.62a3.45,3.45,0,0,0-1.36-.12,54.94,54.94,0,0,1-10.49-.58,10.17,10.17,0,0,0-2.46-.19,3,3,0,0,0-2.15,1",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252,98.08a.86.86,0,0,0-1,0,1,1,0,0,0-.46.85,1.32,1.32,0,0,0,.36.92,1.23,1.23,0,0,0,.68.42,1.11,1.11,0,0,0,1.16-.49,1.21,1.21,0,0,0,0-1.27,1.29,1.29,0,0,0-1.14-.58",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.23,99.33c0,.06-.26.24-.76.26a4.38,4.38,0,0,1-1.87-.39c-1.39-.54-2.26-1.49-2.11-1.61s1,.61,2.3,1.13a7.24,7.24,0,0,0,1.69.5C253.93,99.29,254.21,99.26,254.23,99.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.15,87.57c-.11.1-.32.06-.59.1s-.71.14-1.28.19c-1.1.1-2,0-2-.34s.84-.6,1.94-.7a3.32,3.32,0,0,1,1.52.13C248.16,87.15,248.26,87.49,248.15,87.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.6,82.57c.08,3.55.77,7.06.81,10.6s-.66,7.29-3,10a4.83,4.83,0,0,1-3.15,1.86,1.76,1.76,0,0,1-1.82-.89,2.19,2.19,0,0,1,.2-1.65,38.59,38.59,0,0,1,2.75-4.67,10.73,10.73,0,0,0,1.85-5,15.79,15.79,0,0,0-.56-3.92,8.58,8.58,0,0,1-.15-3.93,3.45,3.45,0,0,1,2.64-2.65",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.88,79.67c11.66-1.27,13.9.79,14,.89a2.29,2.29,0,0,0,.6-1.15C260.9,76,256.72,75,256.72,75c-2.62-11.93-13.34-10.71-13.34-10.71l0-.09a1.93,1.93,0,0,0-2.26-1.53l-1.67.32a1.93,1.93,0,0,0-1.53,2.26h0c-12.58,4.19-8.41,15.82-8.41,15.82l-1.84,2.22c-1.63,3.31,1.91,4.31,1.91,4.31S233.92,81,245.88,79.67Z",
    style: {
      fill: "#089852"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M240,75.6a26.57,26.57,0,0,1-1.43-5,26.5,26.5,0,0,1-.91-5.13,26.48,26.48,0,0,1,1.42,5A26.26,26.26,0,0,1,240,75.6Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M246.28,74.05a24.54,24.54,0,0,1-1.63-4.8,24.72,24.72,0,0,1-1.13-4.93,24.28,24.28,0,0,1,1.63,4.79A24.89,24.89,0,0,1,246.28,74.05Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M256.19,75.49c0,.1-1.5-.34-3.95-.56a29.61,29.61,0,0,0-9.51.76,40.08,40.08,0,0,0-8.94,3.45c-2.18,1.14-3.47,2-3.51,1.9a4.36,4.36,0,0,1,.84-.66c.57-.4,1.42-.95,2.5-1.56a35,35,0,0,1,9-3.64,27.2,27.2,0,0,1,9.67-.62,20.32,20.32,0,0,1,2.89.57A4,4,0,0,1,256.19,75.49Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240.57,77.71a59.48,59.48,0,0,0-6.51,2.78,61.41,61.41,0,0,0-5.87,4,6.26,6.26,0,0,1,1.45-1.52,23.35,23.35,0,0,1,8.87-4.83A6.37,6.37,0,0,1,240.57,77.71Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.59,79.33c-.34.08-.9-.73-1.13-2.25a10,10,0,0,1,5.28-10c1.39-.67,2.37-.67,2.5-.35.28.67-2.66,2.37-4.4,5.75S231.31,79.18,230.59,79.33Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M222,194.28l47.2,4.26c.08-3.23-.9-22.93-1.48-35.87-.11-2.45,2.31-6.7,2.22-8.75-.24-5.1-1-5.3-1-5.3l2.69,5,14-12.47-12.22-16.51a24.2,24.2,0,0,0-16.18-9.57c-1.9-.25-3.34-.38-4.28-.5a27.51,27.51,0,0,1-16.58,0h0a22.55,22.55,0,0,0-6.87,1.32,28.3,28.3,0,0,0-11,7.09h0l-20,23.55L217,158.49l7.12-7.49.92,19.46Z",
    style: {
      fill: "#089852"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.79,140.56c0,.14-7,.26-15.54.26s-15.54-.12-15.54-.26,6.95-.26,15.54-.26S265.79,140.41,265.79,140.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.75,135.5a39.59,39.59,0,0,1-9.06,0,39.59,39.59,0,0,1,9.06,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231,142.61a17.58,17.58,0,0,1-1.91,2.45c-1.23,1.47-3,3.47-4.89,5.67s-3.7,4.15-5,5.56a16.76,16.76,0,0,1-2.19,2.2,19.91,19.91,0,0,1,1.91-2.44c1.24-1.47,3-3.48,4.9-5.68s3.7-4.16,5-5.56A18,18,0,0,1,231,142.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.65,353.6l-1.55,6.48s-10.59,13.75-13.85,13.08c-2.14-.44.49-4,4.51-14.48l.85-4.31Z",
    style: {
      fill: "#089852"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.82,371.13a1.35,1.35,0,0,0,.56.54,2,2,0,0,0,2-.29,57.42,57.42,0,0,0,5.27-5c2-2.06,3.61-4,4.77-5.5l1.35-1.74c.13-.16.26-.32.37-.47l.14-.16s0,.07-.1.18l-.34.5c-.3.43-.74,1-1.3,1.79a69.21,69.21,0,0,1-4.74,5.54,51.11,51.11,0,0,1-5.33,5,2.64,2.64,0,0,1-1.2.44,1.88,1.88,0,0,1-.95-.21,1.19,1.19,0,0,1-.44-.42A.6.6,0,0,1,211.82,371.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.32,366.71a1.7,1.7,0,0,1,.87-.11,4.67,4.67,0,0,1,2,.7,3.65,3.65,0,0,1,1.45,1.53,1.78,1.78,0,0,1,.22.85s-.1-.32-.35-.78a4,4,0,0,0-1.43-1.43,5.19,5.19,0,0,0-1.91-.72C213.65,366.68,213.32,366.74,213.32,366.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.34,363.48a1.35,1.35,0,0,1-.13-.31,5.36,5.36,0,0,1-.21-.89,4.79,4.79,0,0,1,.49-2.95,4.57,4.57,0,0,1,2.15-2.08,3.72,3.72,0,0,1,.87-.27c.22,0,.34,0,.34,0a7.28,7.28,0,0,0-1.15.41,4.63,4.63,0,0,0-2,2.05,4.93,4.93,0,0,0-.53,2.83C223.23,363,223.38,363.47,223.34,363.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227,354.7c.05,0-.18.92-.38,2.07a6.53,6.53,0,0,1-.56,2c-.05,0,.16-.92.35-2.07A6.49,6.49,0,0,1,227,354.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.58,359.6a2.27,2.27,0,0,1,1.36,0,2.38,2.38,0,0,1,1.22.59c0,.06-.56-.22-1.27-.38S216.58,359.66,216.58,359.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.36,360.71a2.1,2.1,0,0,1,2.15.51s-.46-.23-1-.36S216.37,360.77,216.36,360.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.51,362.1a1.72,1.72,0,0,1,2.19.49,5.93,5.93,0,0,0-1-.45A5.42,5.42,0,0,0,215.51,362.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.31,359.13s.48-.14,1.24-.43a11,11,0,0,0,1.27-.61l.71-.45c.21-.16.45-.4.44-.64s-.32-.38-.56-.32a1.61,1.61,0,0,0-.65.43c-.39.37-.72.72-1,1-.54.61-.85,1-.87,1a1.19,1.19,0,0,1,.17-.31c.13-.19.33-.46.59-.77a12.36,12.36,0,0,1,1-1.07,1.66,1.66,0,0,1,.74-.49.62.62,0,0,1,.8.51,1,1,0,0,1-.52.81,8.51,8.51,0,0,1-.73.45,7.63,7.63,0,0,1-1.32.59,6.76,6.76,0,0,1-.94.25A.93.93,0,0,1,217.31,359.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.86,359s-.08-.46-.2-1.18a4.89,4.89,0,0,0-.36-1.23,2.92,2.92,0,0,0-.39-.62c-.17-.18-.41-.33-.6-.22s-.22.4-.19.64a3.4,3.4,0,0,0,.2.71,4.63,4.63,0,0,0,.69,1.06c.49.54.87.81.85.84s-.11,0-.28-.16a4.72,4.72,0,0,1-.67-.58,3.94,3.94,0,0,1-.76-1.09,2.93,2.93,0,0,1-.23-.76.8.8,0,0,1,.29-.84.7.7,0,0,1,.85.27,2.67,2.67,0,0,1,.42.67,4.84,4.84,0,0,1,.33,1.28c0,.37.06.68.06.88S217.88,359,217.86,359Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M226.1,360.08l.75-3.11s-2.6.48-3.27,2.42a8.25,8.25,0,0,0-.51,3.32l-5.64,6.08s-1.41-2.77-4-2.1c0,0-2,4.43-2,5.54s1.36,1,1.82.77a23,23,0,0,0,5.05-4C221.36,365.92,224.66,362,226.1,360.08Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M193.71,177.82a15.71,15.71,0,0,1,.08-20.71l7.88-8.49,14.22,9.14c-.45.31-9.82,10.44-9.82,10.44l16.41,20.45a11.76,11.76,0,0,1,2,11.2l-2.81,11.44L208,205.2l.91-1.4h9l.53-2.16h0Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.54,164.55a9.14,9.14,0,0,1,2.2,1.88,6.3,6.3,0,0,1,1.76,2.3,11.15,11.15,0,0,1-2.13-1.94A7.33,7.33,0,0,1,202.54,164.55Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "234.09 197.07 236.77 145.81 266.14 145.81 268.31 200.15 234.09 197.07",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262,159.08s-.22.22-.68.54a17.78,17.78,0,0,1-2,1.22A27.69,27.69,0,0,1,244.21,164a20.06,20.06,0,0,1-2.34-.33,2.66,2.66,0,0,1-.84-.23c0-.09,1.23.11,3.21.19a32.62,32.62,0,0,0,7.65-.62,32.1,32.1,0,0,0,7.27-2.45C260.94,159.66,262,159,262,159.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.45,166.58c-.15,0-.29-.33-.31-.73s.07-.74.21-.77.28.31.31.73S241.59,166.58,241.45,166.58Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.65,172.21c-.14,0-.15-.66,0-1.44s.36-1.39.5-1.36.15.67,0,1.44S240.79,172.23,240.65,172.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.35,177.77c-.12.08-.56-.45-.78-1.25s-.14-1.46,0-1.47.3.6.5,1.33S241.48,177.7,241.35,177.77Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.13,180.31c0,.14-.66.25-1.47.1s-1.37-.56-1.3-.69.66.05,1.4.18S246.13,180.16,246.13,180.31Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.82,180.26c0,.14-.64.27-1.42.28s-1.43-.1-1.43-.24.64-.27,1.42-.28S251.82,180.11,251.82,180.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.51,180.17c0,.15-.63.28-1.42.29s-1.42-.1-1.43-.24.64-.27,1.43-.28S257.51,180,257.51,180.17Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.14,177.61c.12,0,.05.74-.5,1.4s-1.3.8-1.34.67.48-.46.94-1S262,177.56,262.14,177.61Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.18,172c.14,0,.16.67.05,1.45s-.33,1.39-.47,1.36-.17-.67-.05-1.44S263,172,263.18,172Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.75,166.36c.14,0,.2.65.14,1.44s-.24,1.41-.38,1.39-.2-.66-.14-1.44S263.6,166.35,263.75,166.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.93,162c.14,0,.25.35.24.76s-.14.75-.28.74-.25-.34-.24-.75S263.78,162,263.93,162Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.72,116.6s11.9,3.12,12.1,31.07h4.79s1.26-23.47-11.69-32.69C232.92,115,229.18,114.08,227.72,116.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.88,114.61s8.45,4,8.66,32h4.07s.35-26.17-7.64-31.33A5.73,5.73,0,0,0,252.88,114.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.58,145.53a3.28,3.28,0,0,1,.29,1.59,3,3,0,0,1-.52,1.74,2.58,2.58,0,0,1-2,.94,2.54,2.54,0,0,1-2.1-.8,2.89,2.89,0,0,1-.63-1.7,3.35,3.35,0,0,1,.2-1.6,10.82,10.82,0,0,1,.17,1.56,2.73,2.73,0,0,0,.62,1.43,2.54,2.54,0,0,0,3.4-.13,2.69,2.69,0,0,0,.53-1.46A9.86,9.86,0,0,1,244.58,145.53Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.2,146.36c0-.06.26-.22.63,0a.77.77,0,0,1,.27.73.84.84,0,0,1-1.56.25.74.74,0,0,1,0-.78c.26-.37.59-.31.57-.25s-.17.17-.25.42a.42.42,0,0,0,.06.36.44.44,0,0,0,.38.17.42.42,0,0,0,.3-.28.38.38,0,0,0-.06-.36C242.42,146.46,242.2,146.43,242.2,146.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.7,145.51c.06,0,.29.48.24,1.36a2.93,2.93,0,0,1-.5,1.46,2.31,2.31,0,0,1-1.63,1,1.93,1.93,0,0,1-1.8-.72,3.28,3.28,0,0,1-.47-2.81c.09,0,.11.52.27,1.3a2.68,2.68,0,0,0,.56,1.2,1.52,1.52,0,0,0,1.37.52,2,2,0,0,0,1.31-.8,2.89,2.89,0,0,0,.52-1.23C265.71,146,265.62,145.52,265.7,145.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.43,146.19c-.05,0,.13-.3.57-.24a.75.75,0,0,1,.58.5.83.83,0,0,1-.26.91.81.81,0,0,1-.95,0,.7.7,0,0,1-.32-.7c.09-.45.42-.51.43-.45s-.1.22-.06.46a.34.34,0,0,0,.19.28.39.39,0,0,0,.39,0,.41.41,0,0,0,.12-.38.39.39,0,0,0-.22-.28C263.67,146.19,263.47,146.25,263.43,146.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.15,198.54l30,49.56a7.11,7.11,0,0,1,0,7.39l-27.92,57.58-22.9-12.13,22.76-44.42a7.07,7.07,0,0,0-.57-7.49L241,213.27l1.2-14.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "221.95 191.97 207.47 356.85 231.41 356.85 251.79 216.92 251.48 197.07 221.95 191.97",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.49,199.23a4.07,4.07,0,0,1-.54,1.82,8.29,8.29,0,0,1-7.51,4.67,4,4,0,0,1-1.87-.33c0-.09.72,0,1.86,0a9.26,9.26,0,0,0,4.16-1.33,9.07,9.07,0,0,0,3-3.14C234.2,199.9,234.4,199.2,234.49,199.23Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.75,289.4a5.06,5.06,0,0,1,.1-.82l.41-2.34c.36-2.09.85-5,1.47-8.62,1.21-7.28,2.75-17.36,4.34-28.51s2.92-21.27,3.81-28.6c.42-3.63.77-6.58,1-8.68.11-1,.2-1.78.27-2.36a6.91,6.91,0,0,1,.13-.82,4.72,4.72,0,0,1,0,.83q-.08.89-.18,2.37c-.17,2.06-.46,5-.86,8.7-.79,7.35-2.07,17.47-3.65,28.63s-3.2,21.23-4.5,28.5c-.65,3.64-1.21,6.57-1.63,8.6-.21,1-.38,1.74-.5,2.32A5.59,5.59,0,0,1,240.75,289.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.91,352.84c0,.14-5.44.14-12.13,0s-12.12-.38-12.12-.53,5.43-.14,12.13,0S231.91,352.7,231.91,352.84Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.83,309.63a4.14,4.14,0,0,1-1-.35c-.64-.25-1.56-.64-2.68-1.15-2.24-1-5.3-2.52-8.59-4.36s-6.16-3.66-8.2-5c-1-.69-1.84-1.27-2.39-1.68s-.85-.66-.82-.69a5.27,5.27,0,0,1,.94.52l2.47,1.54c2.08,1.3,5,3.07,8.26,4.9s6.29,3.38,8.49,4.48l2.61,1.3A4.66,4.66,0,0,1,273.83,309.63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.57,351.8c.14,0,.22.36.18.77s-.2.74-.34.72-.22-.36-.18-.77S229.43,351.79,229.57,351.8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.22,345.84c.14,0,.18.7.09,1.52s-.27,1.48-.42,1.46-.18-.7-.09-1.52S230.08,345.82,230.22,345.84Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.88,339.88c.15,0,.19.7.1,1.52s-.29,1.48-.43,1.46-.18-.7-.09-1.52S230.74,339.86,230.88,339.88Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.57,333.92c.14,0,.18.7.09,1.52s-.29,1.48-.44,1.46-.18-.7-.08-1.52S231.43,333.91,231.57,333.92Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.27,328c.15,0,.18.7.08,1.52s-.29,1.47-.43,1.46-.18-.7-.08-1.52S232.13,328,232.27,328Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233,322c.15,0,.18.7.08,1.52s-.3,1.48-.44,1.46-.18-.7-.08-1.52S232.85,322,233,322Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.73,316.06c.15,0,.18.7.08,1.52s-.31,1.48-.45,1.46-.17-.7-.07-1.52S233.59,316.05,233.73,316.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.49,310.12c.14,0,.17.69.07,1.52s-.31,1.47-.45,1.45-.17-.7-.07-1.52S234.35,310.1,234.49,310.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.27,304.17c.14,0,.17.7.06,1.52s-.31,1.47-.45,1.45-.17-.7-.07-1.52S235.12,304.15,235.27,304.17Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.06,298.23c.14,0,.17.7.06,1.52s-.32,1.47-.46,1.45-.17-.7-.06-1.52S235.92,298.21,236.06,298.23Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.87,292.29c.15,0,.17.7.06,1.52s-.32,1.47-.46,1.45-.17-.7-.06-1.52S236.73,292.27,236.87,292.29Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.71,286.35c.14,0,.16.7,0,1.52s-.32,1.47-.46,1.45-.17-.7,0-1.52S237.56,286.33,237.71,286.35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.56,280.41c.14,0,.16.7,0,1.52s-.33,1.47-.47,1.45-.16-.7,0-1.52S238.41,280.39,238.56,280.41Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.42,274.48c.15,0,.16.7,0,1.52s-.33,1.47-.47,1.44-.16-.7,0-1.52S239.28,274.46,239.42,274.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.31,268.55c.14,0,.16.7,0,1.52s-.33,1.46-.48,1.44-.15-.7,0-1.52S240.17,268.53,240.31,268.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.21,262.62c.15,0,.16.7,0,1.52s-.34,1.46-.48,1.44-.16-.7,0-1.52S241.07,262.6,241.21,262.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.14,256.69c.14,0,.15.71,0,1.53s-.35,1.46-.49,1.44-.15-.71,0-1.52S242,256.67,242.14,256.69Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.08,250.77c.14,0,.15.71,0,1.52s-.35,1.47-.5,1.44-.15-.7,0-1.52S242.94,250.75,243.08,250.77Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244,244.85c.14,0,.15.71,0,1.52s-.35,1.47-.5,1.44-.14-.7,0-1.52S243.89,244.83,244,244.85Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245,238.94c.15,0,.15.7,0,1.52s-.36,1.46-.5,1.43-.14-.7,0-1.52S244.87,238.91,245,238.94Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246,233c.14,0,.14.71,0,1.53s-.37,1.45-.51,1.43-.15-.7,0-1.52S245.87,233,246,233Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247,227.11c.14,0,.14.71,0,1.52s-.37,1.46-.52,1.44-.14-.71,0-1.52S246.88,227.09,247,227.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.21,221.23c.14,0,.11.72-.06,1.52s-.43,1.44-.58,1.41-.11-.7.07-1.52S248.07,221.2,248.21,221.23Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250,215.5c.13.05,0,.72-.24,1.5s-.59,1.38-.72,1.34,0-.72.23-1.51S249.81,215.44,250,215.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.84,211.42c.13.08.08.43-.12.79s-.45.6-.57.54-.08-.41.11-.78S251.72,211.35,251.84,211.42Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254,297.58c.12.08,0,.42-.2.77s-.51.56-.63.48,0-.42.19-.77S253.88,297.5,254,297.58Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.26,292.55c.12.08-.14.7-.59,1.4s-.91,1.2-1,1.12.14-.71.59-1.4S257.14,292.47,257.26,292.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.46,287.47c.12.08-.14.71-.58,1.41s-.89,1.21-1,1.13.13-.7.57-1.41S260.33,287.39,260.46,287.47Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.57,282.35c.13.07-.12.7-.55,1.41s-.87,1.23-1,1.15.13-.71.56-1.42S263.45,282.27,263.57,282.35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.62,277.18c.12.07-.12.71-.53,1.42s-.86,1.24-1,1.17.11-.72.53-1.43S266.49,277.1,266.62,277.18Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.59,272c.12.07-.11.71-.52,1.44s-.83,1.25-1,1.17.1-.71.51-1.43S269.46,271.89,269.59,272Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.48,266.71c.12.06-.1.71-.49,1.44s-.82,1.26-.95,1.19.09-.72.49-1.44S272.35,266.64,272.48,266.71Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.29,261.41c.13.06-.08.71-.47,1.45s-.8,1.27-.93,1.2.09-.71.47-1.45S275.16,261.34,275.29,261.41Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.53,255.86c.14,0,.11.72-.17,1.52s-.65,1.38-.78,1.32,0-.71.29-1.49S277.38,255.83,277.53,255.86Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.05,250c.13-.06.53.52.74,1.35s.11,1.54,0,1.55-.29-.64-.49-1.42S276.92,250,277.05,250Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.64,245.07c.1-.09.62.35,1.15,1s.86,1.25.74,1.33-.63-.36-1.15-1S273.53,245.17,273.64,245.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.66,240.58c.11-.1.64.33,1.19.95s.91,1.2.8,1.3-.64-.33-1.19-1S269.55,240.68,269.66,240.58Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.68,236.09c.11-.1.64.33,1.19.95s.91,1.2.8,1.3-.64-.33-1.19-1S265.57,236.19,265.68,236.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.7,231.6c.11-.1.64.33,1.19,1s.91,1.2.8,1.3-.64-.33-1.19-.95S261.6,231.7,261.7,231.6Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.73,227.11c.1-.1.64.33,1.19.95s.9,1.2.8,1.29-.64-.33-1.19-.95S257.62,227.2,257.73,227.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.75,222.62c.11-.1.64.33,1.19.95s.91,1.2.8,1.29-.64-.33-1.19-1S253.64,222.71,253.75,222.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.77,219.25c.11-.09.42.08.69.39s.41.64.3.74-.42-.08-.69-.39S250.66,219.35,250.77,219.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.8,195.79a5.91,5.91,0,0,1,.51.66l1.37,1.93c1.18,1.7,2.85,4.17,4.85,7.27,4,6.17,9.24,14.93,15.23,24.45,3,4.76,6,9.2,8.75,13.21a16.64,16.64,0,0,1,3,6.3,10.38,10.38,0,0,1,.06,3.19,13.58,13.58,0,0,1-.79,2.82A31,31,0,0,1,297.4,260l-2,3.18-1.24,2a5,5,0,0,1-.45.7,5.71,5.71,0,0,1,.36-.75c.25-.49.64-1.18,1.16-2.08l1.92-3.22a31.5,31.5,0,0,0,2.25-4.4,13.86,13.86,0,0,0,.73-2.75,10.45,10.45,0,0,0-.08-3.05,16.36,16.36,0,0,0-2.93-6.11c-2.81-4-5.81-8.44-8.8-13.2-6-9.53-11.15-18.31-15.1-24.54-2-3.12-3.58-5.62-4.71-7.35l-1.29-2A4.05,4.05,0,0,1,266.8,195.79Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Toolbox--inject-9"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "116.04 432.31 115.96 427.51 126.11 412.39 137.72 427.48 137.72 432.31 116.04 432.31",
    style: {
      fill: "#089852"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "116.04 432.31 115.96 427.51 126.11 412.39 137.72 427.48 137.72 432.31 116.04 432.31"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M75.89,414.11c.24-.13,51.19,0,51.19,0v4.26H79.39Z",
    style: {
      fill: "#089852"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M75.89,414.11c.24-.13,51.19,0,51.19,0v4.26H79.39Z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "73.19 412.39 60.88 427.91 60.88 465.71 84.67 465.71 84.67 427.07 73.19 412.39",
    style: {
      fill: "#089852"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "141.97 465.71 141.97 426.92 131.33 412.39 126.08 412.39 137.72 427.48 137.72 432.31 88.88 432.31 88.88 426.21 76.84 412.39 73.19 412.39 84.67 427.07 84.67 465.71 141.97 465.71",
    style: {
      fill: "#089852"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.73,435.43c0,.14-12.86.26-28.71.26s-28.72-.12-28.72-.26,12.85-.26,28.72-.26S141.73,435.29,141.73,435.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.55,463.56c0,.15-12.86.26-28.72.26s-28.71-.11-28.71-.26,12.85-.26,28.71-.26S141.55,463.42,141.55,463.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "73.19 412.39 60.88 427.91 60.88 465.71 84.67 465.71 84.67 427.07 73.19 412.39",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--traffic-cone--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M589.58,465.75v-2a8.33,8.33,0,0,1,8.33-8.33H668.1a8.33,8.33,0,0,1,8.33,8.33v2Z",
    style: {
      fill: "#089852"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.28,376.71l-25.39,78.73h54.23l-23.57-78.67A2.76,2.76,0,0,0,630.28,376.71Z",
    style: {
      fill: "#089852"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "622.01 402.36 643.22 402.36 652.39 432.97 612.13 432.97 622.01 402.36",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "604.88 455.44 659.12 455.44 657.16 448.89 605.94 452.17 604.88 455.44"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M602.06,458.25c0,.08-.67-.06-1.73,0A8.46,8.46,0,0,0,593.4,462c-.6.88-.85,1.5-.92,1.47a3.44,3.44,0,0,1,.6-1.66,7.83,7.83,0,0,1,7.26-3.93A3.41,3.41,0,0,1,602.06,458.25Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M614.39,435.11a52,52,0,0,1-2.31,7,54.09,54.09,0,0,1-2.79,6.83,50.66,50.66,0,0,1,2.3-7A53,53,0,0,1,614.39,435.11Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M632.13,377.33a25.71,25.71,0,0,1-1,3.33c-.7,2.17-1.59,4.91-2.58,7.94s-1.85,5.77-2.54,7.95a25.57,25.57,0,0,1-1.15,3.27,21,21,0,0,1,.8-3.38c.56-2.06,1.4-4.9,2.4-8s2-5.9,2.72-7.91A21.46,21.46,0,0,1,632.13,377.33Z",
    style: {
      fill: "#fff"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenance);
export default __webpack_public_path__ + "static/media/maintenance.a7f3821b447cd122360bda80af520ac6.svg";
export { ForwardRef as ReactComponent };